import React, { Component } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { connect } from "react-redux";
import { InputMask } from "primereact/inputmask";
import { InputNumber } from "primereact/inputnumber";
import { DataTable } from "primereact/datatable";
import axios from "axios";
import { Column } from "primereact/column";
import "./Payment.css";
import { Carousel } from "primereact/carousel";
import { Toast } from "primereact/toast";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import moment from "moment";
import { SelectButton } from "primereact/selectbutton";
import {
  setUserSessionAuthKey,
  numberWithCommasAndSpace,
  numberWithSpace,
  previewPdf
} from "../../Component/commonUtils";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import TranslationPackageInfo from "../15-Translation/TranslationPackageInfo.json";
import NavBarHeader from "../NavBarHeader/NavBarHeader";
import config from "../../Configuration/Config";
import Footer_contact_tab from "../Footerpage/Footer_contact_tab";
import Joyride, { CallBackProps, STATUS, Step } from "react-joyride";
import { Helmet } from "react-helmet-async";
import { Messages } from "primereact/messages";
import { ProgressSpinner } from "primereact/progressspinner";
import NoAccess from "../../Component/NoAccess/NoAccess";

const mapStateToProps = (state) => {
  return {
    annualReportType: state.annualReportType.annualReportType.values,
    companyInformation: state.companyInformation.companyInformation,
    financialYear: state.financialYear.financialYear,
    sessionDetails: state.sessionDetails.sessionDetails.values,
    login: state.login.login.values,
    sideBarReducer: state.sideBarReducer.sideBarReducer,
    prices: state.prices.prices,
    currentPageName: state.currentPageName.currentPageName,
    payment: state.payment.payment
  };
};

let userSelectedLanguage;
let cartValuesLocalData = [];
let defaultPackageValue = [],
  restOfThePackage = [],
  filteredStatementType = [],
  finalCheckoutArray = [],
  gridData = [],
  carouselData = [],
  confirmDiscountOK = 0,
  custType = "",
  sideBarGreenTickPages = [],
  previouslyBoughtPackages = [],
  gCurrentReportGUIDFromUrl = "",
  annualReportHeaderAPIResp = "",
  navigationUrl = "",
  gDiscountErrorResponseStatus = null;
let iFrameID = "",
  showPayment,
  unitPriceWithMomsMultiByQty = "",
  rebelSkoolUserLSParse = "";
let rebelSkoolUserLS = localStorage.getItem("rebelSkoolUser");
const responsiveOptions = [
  {
    breakpoint: "1199px",
    numVisible: 1,
    numScroll: 1
  },
  {
    breakpoint: "991px",
    numVisible: 1,
    numScroll: 1
  }
];
let userSessionAuthKeyReturnValue = setUserSessionAuthKey();
let tourGuidePages = localStorage.getItem("tourGuidePages");
let currentPageTourGuideName = "PaymentPage";

let testData = [],
  billingInfoUpdated = false,
  payFromHome = false,
  paymentStatus = null;

let steps = [];

class NetsPayment extends Component {
  constructor(props) {
    super(props);
    this.msgs = React.createRef();
    this.errorMsgs = React.createRef();

    this.billingTypeOptions = ["Private", "Company"];

    // this.billingTypeOptions = [
    //  TranslationFile.loginPrivateText[userSelectedLanguage],
    // TranslationFile.netsPaymentCompany[userSelectedLanguage]];

    this.state = {
      sideBarStatus: true,
      companyName: "",
      currentFinancialYear: "",
      organizationNumber: "",
      postalCode: "",
      city: "",
      activeIndex: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      toggleOpen: false,
      userCompanyType: "Private Company",
      paymentType: "Credit Card",
      orgNumber: "",
      accountingCompanyOrgName: "",
      accountingCompanyPostalCode: "",
      accountingCompanyCity: "",
      emailId: "",
      name: "",
      lastName: "",
      pricesList: [],
      defaultPrice: [],
      discountCodeRupee: 0,
      totalReportCount: 0,
      totalUsedReportCount: 0,
      remainingReportCount: 0,
      packageEntryNoToUse: 0,
      currentFinancialYear: "",
      activePackageAvailable: "",
      registrationNoFromDB: "",
      postalCodeFromDB: "",
      cityFromDB: "",
      iframeKey: 0,
      totalPriceExcMoms: "",
      totalMoms: "",
      totalPriceIncMoms: "",
      paymentEntryNo: "",
      showPaidDialogBox: false,
      billingAddress: "",
      reportPaymentCheckout: false,
      isLoading: true,
      run: false,
      paymentId: null,
      billingType: this.billingTypeOptions[1],
      showPaymentAccordion: false,
      showPaymentIframe: false,
      billingInfoEdit: false,
      contactNumber: "",
      countryCode: "",
      payBtnEnable: false,
      discountInput: null,
      discountResponse: null,
      discountErrorResponseStatus: null,
      discountApplyLoading: null,
      width: window.innerWidth,
      careOf: "",
      accessLevel: 0,
      invalidFields: {}
    };

    this.removeBodyTemplate = this.removeBodyTemplate.bind(this);
    this.quantityBodyTemplate = this.quantityBodyTemplate.bind(this);
    this.carouselButton = this.carouselButton.bind(this);
    this.packageCarouselRender = this.packageCarouselRender.bind(this);
    this.navigateToPaymentConfirmation =
      this.navigateToPaymentConfirmation.bind(this);
  }
  sideBarStatus = (e) => {
    this.setState({
      sideBarStatus: e
    });
  };

  handleResize = () => {
    this.setState({
      width: window.innerWidth
    });
  };

  organizationNoOnComplete(e) {
    let { companyInformation, payment, login } = this.props;
    const { paymentId } = this.state;

    this.setState({
      organizationNumber: e.value
    });
    if (userSessionAuthKeyReturnValue) {
      payment.values.organizationnumber = e.value;
      axios
        .get("/organization/get/" + e.value, userSessionAuthKeyReturnValue)
        .then((response) => {
          if (response.data != "") {
            this.setState({
              organizationNumber: response.data.organizationnumber,
              companyName: response.data.organizationname,
              postalCode: response.data.postalcode,
              city: response.data.city
            });
            let companyInformationValue = {
              organizationname: response.data.organizationname,
              organizationnumber: response.data.organizationnumber,
              postalcode: response.data.postalcode,
              city: response.data.city
            };
            payment.values.organizationnumber =
              response.data.organizationnumber;
            payment.values.organizationname = response.data.organizationname;
            payment.values.postalcode = response.data.postalcode;
            payment.values.city = response.data.city;

            // companyInformation.values = companyInformationValue;

            // let billingInfo = {
            //   key: "all",
            //   value: "all",
            //   // userId: login.userID,
            //   checkoutId: paymentId,
            //   companyName: response.data.organizationname,
            //   registrationNo: response.data.organizationnumber,
            //   postalCode: response.data.postalcode,
            //   city: response.data.city,
            //   name: this.state.name,
            //   lastName: this.state.lastName,
            //   emailId: this.state.emailId,
            //   // mobileNumber:
            //   //   this.state.countryCode + " " + this.state.contactNumber,
            // };

            // axios
            //   .post(
            //     "/annualReportPackage/updatePaymentHeaderBillingInfo",
            //     billingInfo,
            //     userSessionAuthKeyReturnValue
            //   )
            //   .then((updateCompanyNumberResponse) => {});
          }
        });
    }
  }

  organizationNoOnChange(e, organizationNumber) {
    const { payment } = this.props;
    payment.values.organizationnumber = e.value;
    this.setState({
      organizationNumber: e.value,
      invalidFields: Object.assign({}, this.state.invalidFields, {
        organizationNumber: false
      })
    });
  }

  companyNameOnChange(e, companyName) {
    const { payment } = this.props;
    this.setState({
      accountingCompanyOrgName: e.target.value,
      companyName: e.target.value
    });
    payment.values.organizationname = e.target.value;
    this.setState({
      invalidFields: Object.assign({}, this.state.invalidFields, {
        companyName: false
      })
    });
  }

  PostalcodeOnChange(e, postalCode) {
    const { payment } = this.props;
    const numericOnlyValue = e.target.value.replace(/\D/g, "");
    this.setState({
      accountingCompanyPostalCode: numericOnlyValue,
      postalCode: numericOnlyValue
    });
    payment.values.postalcode = numericOnlyValue;
    this.setState({
      invalidFields: Object.assign({}, this.state.invalidFields, {
        postalCode: false
      })
    });
  }

  cityOnChange(e, city) {
    const { payment } = this.props;
    this.setState({
      accountingCompanyCity: e.target.value,
      city: e.target.value
    });
    payment.values.city = e.target.value;
    this.setState({
      invalidFields: Object.assign({}, this.state.invalidFields, {
        city: false
      })
    });
  }

  countryCodeOnChange(e) {
    this.setState({
      countryCode: e.target.value
    });
  }
  // contactNumberOnBlur(e) {
  //   const { paymentId, countryCode, contactNumber } = this.state;

  //   if (countryCode != "" && contactNumber != "") {
  //     let billingInfo = {
  //       key: "contactNumber",
  //       value: countryCode + " " + e.target.value,
  //       checkoutId: paymentId,
  //     };

  //     axios
  //       .post(
  //         "/annualReportPackage/updatePaymentHeaderBillingInfo",
  //         billingInfo,
  //         userSessionAuthKeyReturnValue
  //       )
  //       .then((updateCompanyNameResponse) => {});
  //   }
  // }

  contactNumberOnChange(e) {
    this.setState({
      contactNumber: e.target.value
    });
    this.setState({
      invalidFields: Object.assign({}, this.state.invalidFields, {
        contactNumber: false
      })
    });
  }

  paymentNameOnChange(e, name) {
    const { payment } = this.props;
    if (name == "name") {
      this.setState({
        name: e.target.value
      });
    } else {
      this.setState({
        lastName: e.target.value
      });
    }

    payment.values.name = e.target.value;

    this.setState({
      invalidFields: Object.assign({}, this.state.invalidFields, {
        [name === "name" ? "name" : "lastName"]: false
      })
    });

    //  this.setState({
    //    invalidFields: Object.assign({}, this.state.invalidFields, {
    //     lastName: false
    //   })
    // });
  }

  // paymentNameOnBlur(e, name) {
  //   const { paymentId } = this.state;

  //   let billingInfo = "";
  //   if (name == "name") {
  //     billingInfo = {
  //       key: "name",
  //       value: e.target.value,
  //       checkoutId: paymentId,
  //     };
  //   } else {
  //     billingInfo = {
  //       key: "lastName",
  //       value: e.target.value,
  //       checkoutId: paymentId,
  //     };
  //   }
  //   axios
  //     .post(
  //       "/annualReportPackage/updatePaymentHeaderBillingInfo",
  //       billingInfo,
  //       userSessionAuthKeyReturnValue
  //     )
  //     .then((updateCompanyNameResponse) => {});
  // }

  paymentEmailOnChange(e, emailId) {
    const { payment } = this.props;
    this.setState({
      emailId: e.target.value
    });
    payment.values.emailId = e.target.value;
    this.setState({
      invalidFields: Object.assign({}, this.state.invalidFields, {
        emailId: false
      })
    });
  }
  // paymentEmailOnBlur(e) {
  //   const { paymentId } = this.state;

  //   let billingInfo = {
  //     key: "emailId",
  //     value: e.target.value,
  //     checkoutId: paymentId,
  //   };

  //   axios
  //     .post(
  //       "/annualReportPackage/updatePaymentHeaderBillingInfo",
  //       billingInfo,
  //       userSessionAuthKeyReturnValue
  //     )
  //     .then((updateCompanyNameResponse) => {});
  // }

  handleChange(toggleOpen) {
    window.scroll(0, 0);
    if (toggleOpen == true) {
      let exp = [0, 1, 2, 3, 4, 5, 6];
      this.setState({ activeIndex: exp });
      this.setState({ toggleOpen: false });
    } else {
      let collapse = [];
      this.setState({ activeIndex: collapse });
      this.setState({ toggleOpen: true });
    }
  }

  removePackageFromCart(rowData) {
    const { login } = this.props;

    if (gridData.length == 1) {
      this.toast.show({
        severity: "warn",
        summary: "Couldn't delete the package",
        detail: "The Cart should have atleast 1 package",
        life: 3000
      });
    } else {
      let cartValuesLocalDataTemp =
        JSON.parse(localStorage.getItem("cartValues")) || [];
      let filteredPeople =
        login != undefined &&
        cartValuesLocalDataTemp &&
        cartValuesLocalDataTemp.filter((item) => item.userID == login.userID);
      let cartArrayList =
        filteredPeople &&
        filteredPeople.length > 0 &&
        filteredPeople[0].cartArray;

      const arr = cartArrayList.filter(
        (item) => item.packageId != rowData.packageId && item.quantity > 0
      );
      gridData = arr;
      gridData =
        gridData &&
        gridData.filter((val) => val.application == "Annual Report");
      let cartWithUserID = [
        {
          userID: login.userID,
          cartArray: arr
        }
      ];
      localStorage.setItem("cartValues", []);
      localStorage.setItem("cartValues", JSON.stringify(cartWithUserID));
      cartValuesLocalData = cartWithUserID;
      // this.updatePaysonCheckout();
      this.createPaymentData("update", false);
      this.setState({
        reRender: true
      });

      this.setState({
        discountInput: null,
        discountResponse: null,
        discountErrorResponseStatus: null
      });
      gDiscountErrorResponseStatus = null;
    }
  }

  handleQuantityChange(item, d) {
    const {
      discountResponse,
      discountErrorResponseStatus,
      discountInput,
      totalPriceExcMoms
    } = this.state;

    if (gridData.length == 1 && gridData[0].quantity == 1 && d < 0) {
      this.toast.show({
        severity: "warn",
        summary: "Couldn't delete the package",
        detail: "The Cart should have atleast 1 package",
        life: 3000
      });
    } else {
      const { login } = this.props;
      // cartValuesLocalData =
      //   JSON.parse(localStorage.getItem("cartValues")) || [];
      let filteredPeople =
        login != undefined &&
        cartValuesLocalData &&
        cartValuesLocalData.filter((item) => item.userID == login.userID);
      let cartArrayList =
        filteredPeople &&
        filteredPeople.length > 0 &&
        filteredPeople[0].cartArray;

      let removedJunkObj = cartArrayList;

      if (filteredPeople && filteredPeople.length > 0) {
        removedJunkObj =
          filteredPeople[0].cartArray &&
          filteredPeople[0].cartArray.length &&
          filteredPeople[0].cartArray.filter((item) => item.quantity > 0);
      }

      let cartValuesHandleChange = removedJunkObj;

      let ind = -1;
      cartValuesHandleChange.forEach((data, index) => {
        if (data.packageId == item.packageId) ind = index;
      });

      cartValuesHandleChange[ind].quantity =
        cartValuesHandleChange[ind].quantity + d;

      let cartWithUserID = [
        {
          userID: login.userID,
          cartArray: cartValuesHandleChange
        }
      ];

      gridData = cartValuesHandleChange;
      gridData =
        gridData &&
        gridData.filter((val) => val.application == "Annual Report");
      localStorage.setItem("cartValues", JSON.stringify(cartWithUserID));

      if (cartValuesHandleChange[ind].quantity <= 0) {
        this.removePackageFromCart(cartValuesHandleChange[ind]);
      }

      this.setState({
        discountInput: null,
        discountResponse: null,
        discountErrorResponseStatus: null
      });
      gDiscountErrorResponseStatus = null;

      // this.updatePaysonCheckout();
      this.createPaymentData("update", false);

      this.setState({
        reRender: true
      });
    }
  }

  removeBodyTemplate(rowData) {
    return (
      <div>
        <Button
          icon="pi pi-times"
          rounded
          text
          severity="danger"
          aria-label={TranslationFile.CancelBtn[userSelectedLanguage]}
          onClick={() => this.removePackageFromCart(rowData)}
        />
      </div>
    );
  }

  priceBodyTemplate(rowData) {
    return (
      <div>{numberWithCommasAndSpace(rowData.price * rowData.quantity)} kr</div>
    );
  }
  unitPriceBodyTemplate(rowData) {
    return <div>{numberWithCommasAndSpace(rowData.price)} kr</div>;
  }

  quantityBodyTemplate(rowData) {
    return (
      <div>
        <span>
          <Button
            icon="pi pi-minus"
            text
            outlined
            aria-label={TranslationFile.CancelBtn[userSelectedLanguage]}
            onClick={() => this.handleQuantityChange(rowData, -1)}
            className="cart-plus-button"
          />
        </span>
        <span>
          <label
            style={{
              width: "2.2em",
              height: "2em",
              paddingLeft: "12px"
            }}
            className="cart-item-amount22"
          >
            {rowData.quantity}
          </label>
        </span>
        <span>
          <Button
            icon="pi pi-plus"
            text
            aria-label={TranslationFile.CancelBtn[userSelectedLanguage]}
            className="cart-plus-button"
            onClick={() => this.handleQuantityChange(rowData, +1)}
          />
        </span>
      </div>
    );
  }

  settingDefaultCartValue(defaultValue) {
    const { login } = this.props;
    if (login != undefined) {
      let pricesListWithoutAddOn = defaultValue.filter(
        (obj) => obj.visibleInGrid
      );

      if (login.isAccountingCompany) {
        carouselData = defaultValue;
      } else {
        carouselData = pricesListWithoutAddOn;
      }
      // login.isAccountingCompany
      //   ? (carouselData = defaultValue)
      //   : (carouselData = pricesListWithoutAddOn);
      gridData = defaultValue;

      // carouselData = gridData;
      gridData = defaultValue.filter((item) =>
        (item.customerType == login.accountingCompanyRegNo) != null
          ? "Accounting Company"
          : "User (Private person)"
      );

      gridData =
        gridData &&
        gridData.filter(
          (e) => e.packageId === Math.min(...gridData.map((f) => f.packageId))
        );
      gridData[0]["quantity"] = 1;

      gridData =
        gridData &&
        gridData.filter((val) => val.application == "Annual Report");
      this.updateTotalAmounts(gridData);

      this.setState({
        reRender: true
      });

      cartValuesLocalData =
        (localStorage.getItem("cartValues") &&
          JSON.parse(localStorage.getItem("cartValues"))) ||
        [];

      let otherUsersCartArray =
        cartValuesLocalData &&
        cartValuesLocalData.filter((item) => item.userID != login.userID);

      let cartWithUserID = {
        userID: login.userID,
        cartArray: gridData
      };

      otherUsersCartArray.push(cartWithUserID);
      localStorage.setItem("cartValues", JSON.stringify(otherUsersCartArray));
    }
  }

  updateTotalAmounts(cartArrayList) {
    let totalPriceExcMomsLoc = 0.0;
    cartArrayList &&
      cartArrayList.length &&
      cartArrayList.map((item, itemIdx) => {
        totalPriceExcMomsLoc =
          totalPriceExcMomsLoc + item.price * item.quantity;

        if (cartArrayList.length == itemIdx + 1) {
          let totalMomsLoc = 0.0;
          totalMomsLoc = totalPriceExcMomsLoc * 0.25;

          let totalPriceIncMomsLoc = 0.0;
          totalPriceIncMomsLoc = totalPriceExcMomsLoc + totalMomsLoc;

          this.setState({
            totalPriceExcMoms: numberWithCommasAndSpace(
              totalPriceExcMomsLoc.toFixed(2)
            ),
            totalMoms: numberWithCommasAndSpace(totalMomsLoc.toFixed(2)),
            totalPriceIncMoms: numberWithCommasAndSpace(
              totalPriceIncMomsLoc.toFixed(2)
            )
          });
        }
      });
  }

  getAnnualReportPackageUsageAPICall(login) {
    if (userSessionAuthKeyReturnValue) {
      let cartValuesLocalData =
        JSON.parse(localStorage.getItem("cartValues")) || [];
      let filteredPeople =
        login != undefined &&
        cartValuesLocalData &&
        cartValuesLocalData.filter((item) => item.userID == login.userID);
      let cartArrayList =
        filteredPeople &&
        filteredPeople.length > 0 &&
        filteredPeople[0].cartArray;

      let { activePackageAvailable } = this.state;
      axios
        .get(
          "/annualReportPackage/getPaymentLines",
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          let activePackageList = response.data.filter(
            (obj) => obj.status == true
          );

          if (activePackageList.length > 0) {
            this.setState({ activePackageAvailable: true });
          }
          let packageWithDateDiffernceList = [],
            packageWithUnlimitedDateList = [];

          activePackageList.length &&
            activePackageList.map((i, idx) => {
              let startDate = moment(i.startingDate);
              let endDate = moment(i.validUntil);
              let dateDifference = startDate.diff(endDate, "days");

              let packageWithDateDiffernce = {
                entryNo: 0,
                dateDifference: 0
              };

              packageWithDateDiffernce.entryNo = i.entryNo;
              if (dateDifference < 0) {
                packageWithDateDiffernce.dateDifference = dateDifference * -1;
                packageWithDateDiffernceList.push(packageWithDateDiffernce);
              } else {
                packageWithUnlimitedDateList.push(packageWithDateDiffernce);
              }
            });

          let lowestDifferenceDate = [];
          let getLowestDifferenceDateObj = [];

          if (packageWithDateDiffernceList.length > 0) {
            lowestDifferenceDate = Math.min(
              ...packageWithDateDiffernceList.map((item) => item.dateDifference)
            );

            getLowestDifferenceDateObj = packageWithDateDiffernceList.filter(
              (obj) => {
                return obj.dateDifference == lowestDifferenceDate;
              }
            );
          } else {
            lowestDifferenceDate = packageWithUnlimitedDateList[0];
            if (lowestDifferenceDate != undefined)
              getLowestDifferenceDateObj = [lowestDifferenceDate];
          }

          this.setState({
            packageEntryNoToUse:
              getLowestDifferenceDateObj.length &&
              getLowestDifferenceDateObj[0].entryNo
          });

          let totalReportCount = activePackageList.reduce(
            (obj, { maxUsage }) => obj + maxUsage,
            0
          );
          this.setState({
            totalReportCount: totalReportCount
          });

          let totalUsedReportCount = activePackageList.reduce(
            (obj, { actualUsage }) => obj + actualUsage,
            0
          );
          this.setState({
            totalUsedReportCount: totalUsedReportCount
          });

          let remainingReportCount = totalReportCount - totalUsedReportCount;
          this.setState({
            remainingReportCount: remainingReportCount
          });
        });
    }
  }

  componentWillReceiveProps() {
    const { login } = this.props;
    cartValuesLocalData =
      (localStorage.getItem("cartValues") &&
        JSON.parse(localStorage.getItem("cartValues"))) ||
      [];
    let filteredPeople =
      login != undefined &&
      cartValuesLocalData &&
      cartValuesLocalData.filter((item) => item.userID == login.userID);
    let cartArrayList =
      filteredPeople &&
      filteredPeople.length > 0 &&
      filteredPeople[0].cartArray;
    gridData = cartArrayList;
    gridData =
      gridData && gridData.filter((val) => val.application == "Annual Report");
  }

  componentDidMount() {
    const { prices, login, companyInformation, payment } = this.props;

    const { organizationNumber, companyName, postalCode, city } = this.state;

    // Initial log
    // console.log("Initial width:", window.innerWidth);

    // Listen to resize
    window.addEventListener("resize", this.handleResize);

    if (login != undefined && userSessionAuthKeyReturnValue) {
      // From Reducer
      this.setState({
        emailId: login.emailID,
        name: login.userName
      });

      payment.values.name = login.userName;
      payment.values.emailId = login.emailID;

      if (
        login.accountingCompanyRegNo != null &&
        login.accountingCompanyRegNo != ""
      ) {
        axios
          .get(
            "/accountingCompany/getCompanyDetailsAndUsers?accountingCompanyId=" +
              login.accountingCompanyRegNo,
            userSessionAuthKeyReturnValue
          )
          .then((response) => {
            this.setState({
              accountingCompanyOrgName:
                response.data.accountingCompany &&
                response.data.accountingCompany.accountingCompanyName,
              accountingCompanyPostalCode:
                response.data.accountingCompany &&
                response.data.accountingCompany.postalCode,
              accountingCompanyCity:
                response.data.accountingCompany &&
                response.data.accountingCompany.city
            });
          });
      }
    }
  }

  componentWillUnmount() {
    // Cleanup
    window.removeEventListener("resize", this.handleResize);
  }

  handleAddToCartClick(item) {
    defaultPackageValue.push(item);
    this.setState({
      rerender: true
    });
  }
  handleCartPrice() {
    const { login } = this.props;
    let cartValuesLocalData =
      (localStorage.getItem("cartValues") &&
        JSON.parse(localStorage.getItem("cartValues"))) ||
      [];
    let filteredPeople = [];
    if (login != undefined) {
      filteredPeople =
        cartValuesLocalData &&
        cartValuesLocalData.filter((item) => item.userID == login.userID);
    }
    let cartArrayList =
      filteredPeople &&
      filteredPeople.length > 0 &&
      filteredPeople[0].cartArray;
  }

  callback = (annualReport, session, link, status) => {
    const { login } = this.props;
    cartValuesLocalData = JSON.parse(localStorage.getItem("cartValues") || []);
    let filteredPeople =
      login != undefined &&
      cartValuesLocalData &&
      cartValuesLocalData.filter((item) => item.userID == login.userID);
    let cartArrayList =
      filteredPeople &&
      filteredPeople.length > 0 &&
      filteredPeople[0].cartArray;
    let gridDataTemp = [];

    cartArrayList &&
      cartArrayList.length &&
      cartArrayList.map((i, idx) => {
        i.unitPrice = i.price + (i.price * 25) / 100;
        gridDataTemp.push(i);
      });
    gridData = gridDataTemp;
    gridData =
      gridData && gridData.filter((val) => val.application == "Annual Report");
    // gridData = cartArrayList;

    this.setState({
      reRender: true
    });
  };
  languageValue = (e) => {
    this.setState({
      selectedLanguage: e
    });
  };

  // updatePaysonCheckout = () => {
  //   const { login, payment } = this.props;
  //   itemsForPostPayson = [];
  //   if (userSessionAuthKeyReturnValue) {
  //     let itemsObject = {
  //       name: "",
  //       unitPrice: 0,
  //       quantity: 0,
  //       taxRate: 0.25,
  //     };

  //     let totalSumIncludingMoms = 0;
  //     gridData &&
  //       gridData.length &&
  //       gridData.map((val) => {
  //         itemsObject = {
  //           name: val.text1,
  //           packageId: val.packageId,
  //           packageDetailsName: val.packageName,
  //           accountingCompanyId: login.isAccountingCompany == true ? 1 : 0,
  //           unitPrice: val.price + (val.price * 25) / 100,
  //           quantity: val.quantity,
  //           taxRate: 0,
  //           status: 1,
  //           maxUsage: val.maxUsage * val.quantity,
  //           actualUsage: 0,
  //           type: "service",
  //         };
  //         itemsForPostPayson.push(itemsObject);
  //       });
  //     gridData =
  //       gridData &&
  //       gridData.filter((val) => val.application == "Annual Report");

  //     this.updateTotalAmounts(gridData);

  //     const annualReport = "/annualreport/";

  //     let updateCheckout = {
  //       application: "Annual Report",
  //       userId: login.userID,
  //       status: "created",
  //       id: paysonIDFromResponse,
  //       merchant: {
  //         checkoutUri: "https://www.examplestore.com/checkout.php",
  //         confirmationUri: navigationUrl,
  //         // notificationUri: "https://www.examplestore.com/notification.php",
  //         notificationUri:
  //           config.annualReport.url +
  //           "/notification?checkout=" +
  //           paysonIDFromResponse,
  //         termsUri: "https://www.examplestore.com/terms.php",
  //       },
  //       order: {
  //         currency: "sek",
  //         items: itemsForPostPayson,
  //       },
  //     };
  //     axios
  //       .put(
  //         "/annualReportPackage/paysonUpdateCheckout",
  //         updateCheckout,
  //         userSessionAuthKeyReturnValue
  //       )
  //       .then((response) => {
  //         if (response.data) {
  //           paysonIDFromResponse = response.data.id;
  //           payment.values.checkoutRef = paysonIDFromResponse;
  //           iFrameID =
  //             "https://test-www.payson.se/embedded/checkout?id=" +
  //             paysonIDFromResponse;

  //           this.setState({
  //             rerender: true,
  //             iframeKey: this.state.iframeKey + 1,
  //           });
  //         }
  //       });
  //   }
  // };

  checkInputFields(navToPaymentConfirmation, navigateToReviewPage) {
    const {
      name,
      lastName,
      emailId,
      organizationNumber,
      companyName,
      billingType,
      billingAddress,
      accountingCompanyPostalCode,
      accountingCompanyCity,
      city,
      postalCode
    } = this.state;

    const cleanPostalCode = postalCode.replace(/\s/g, "");

    this.setState({
      postalCode: cleanPostalCode
    });

    const isPostalCodeValid = cleanPostalCode.length === 5;

    /* if (cleanPostalCode.length != 5) {
      this.setState({
        invalidFields: {
          postalCode: true
        }
      });

      this.toast.show({
        severity: "error",
        summary: TranslationFile.InvalidPostalCodeSummary[userSelectedLanguage],
        detail: TranslationFile.InvalidPostalCodeDetail[userSelectedLanguage],
        life: 3000
      });

      return false;
    } */

    const isNotEmpty = (value) => value && value.trim() !== "";
    const hasValidEmailFormat = (value) => {
      const normalizedEmail = (value || "").trim().toLowerCase();
      if (!normalizedEmail) {
        return false;
      }
      return (
        normalizedEmail.includes("@") &&
        normalizedEmail.includes(".com") &&
        normalizedEmail.indexOf("@") < normalizedEmail.lastIndexOf(".com")
      );
    };

    let isMandatoryFieldsValid = false;
    let isEmailValid = hasValidEmailFormat(emailId);

    // build invalidFields object so UI can highlight them
    let invalidFields = {};

    if (
      billingType === "Company" ||
      billingType === TranslationFile.netsPaymentCompany[userSelectedLanguage]
    ) {
      const checks = {
        name: isNotEmpty(name),
        lastName: isNotEmpty(lastName),
        organizationNumber: isNotEmpty(organizationNumber),
        companyName: isNotEmpty(companyName),
        postalCode: isPostalCodeValid,
        city: isNotEmpty(city),
        billingAddress: isNotEmpty(billingAddress)
      };
      isMandatoryFieldsValid = Object.values(checks).every(Boolean);
      Object.keys(checks).forEach((k) => (invalidFields[k] = !checks[k]));
    } else if (
      billingType === "Private" ||
      billingType === TranslationFile.loginPrivateText[userSelectedLanguage]
    ) {
      const checks = {
        name: isNotEmpty(name),
        lastName: isNotEmpty(lastName),
        postalCode: isPostalCodeValid,
        city: isNotEmpty(city),
        billingAddress: isNotEmpty(billingAddress)
      };
      isMandatoryFieldsValid = Object.values(checks).every(Boolean);
      Object.keys(checks).forEach((k) => (invalidFields[k] = !checks[k]));
    }

    // email invalid flag
    invalidFields.emailId = !isEmailValid;

    // ensure all flags are strictly boolean
    Object.keys(invalidFields).forEach((k) => {
      invalidFields[k] = !!invalidFields[k];
    });

    const isValid = isMandatoryFieldsValid && isEmailValid;

    if (isValid) {
      this.setState({
        showPaymentAccordion: true,
        showPaymentIframe: true,
        billingInfoEdit: true
      });

      if (navigateToReviewPage) {
        const annualReport = "/annualreport/";
        let navigationURL =
          annualReport + gCurrentReportGUIDFromUrl + "/reviewAndSend";

        this.createPaymentData("create", navToPaymentConfirmation);
        this.props.history.push(navigationURL);
      } else this.createPaymentData("create", navToPaymentConfirmation);
    } else {
      // set invalid fields for UI highlighting
      this.setState({ invalidFields: invalidFields });

      if (!isMandatoryFieldsValid) {
        const postalCodeFilledButInvalid =
          cleanPostalCode.length > 0 && !isPostalCodeValid;

        if (postalCodeFilledButInvalid) {
          this.toast.show({
            severity: "error",
            summary:
              TranslationFile.InvalidPostalCodeSummary[userSelectedLanguage],
            detail:
              TranslationFile.InvalidPostalCodeDetail[userSelectedLanguage],
            life: 3000
          });
        } else {
          this.toast.show({
            severity: "error",
            summary: "Please fill the mandatory fields",
            detail: "Please fill the mandatory fields billing information",
            life: 3000
          });
        }
      } else if (!isEmailValid) {
        if (emailId.trim() === "") {
          this.toast.show({
            severity: "error",
            summary: "Email is required",
            detail: "Please fill the mandatory fields billing information",
            life: 3000
          });
        } else {
          this.toast.show({
            severity: "error",
            summary: "Invalid email address",
            detail: "Email must include @ and .com",
            life: 3000
          });
        }
      }
    }
  }

  allowPayment() {
    if (
      annualReportHeaderAPIResp &&
      annualReportHeaderAPIResp.reportID == null
    ) {
      //Only Payment
      this.checkInputFields(false, false);
    } else {
      if (
        sideBarGreenTickPages.includes("Company Information") &&
        sideBarGreenTickPages.includes("Income Statement") &&
        sideBarGreenTickPages.includes("Balance Sheet") &&
        sideBarGreenTickPages.includes("Notes") &&
        sideBarGreenTickPages.includes("Management Statement") &&
        sideBarGreenTickPages.includes("Representative")
      ) {
        this.checkInputFields(false, false);
      } else {
        this.toast.show({
          severity: "error",
          summary: "Please Complete the previous forms",
          detail: "Please Complete the previous forms",
          life: 3000
        });
      }
    }
  }

  editBillingInfo() {
    this.setState({
      showPaymentAccordion: false,
      showPaymentIframe: false,
      billingInfoEdit: false
    });
  }

  createPaymentData(type, navToPaymentConfirmation) {
    const { login, payment } = this.props;
    const {
      registrationNoFromDB,
      organizationNumber,
      accountingCompanyOrgName,
      companyNameFromDB,
      companyName,
      accountingCompanyPostalCode,
      postalCodeFromDB,
      postalCode,
      accountingCompanyCity,
      cityFromDB,
      discountResponse,
      city
    } = this.state;

    paymentStatus = type;
    // cartValuesLocalData = JSON.parse(localStorage.getItem("cartValues"));
    if (cartValuesLocalData == null) {
      cartValuesLocalData = [];
    }

    if (cartValuesLocalData.length == 0) {
      let cartObjTemp = {
        cartArray: gridData,
        userID: login.userID
      };
      cartValuesLocalData.push(cartObjTemp);
    }
    let filteredPeople = [];
    if (login != undefined) {
      filteredPeople =
        cartValuesLocalData &&
        cartValuesLocalData.filter((item) => item.userID == login.userID);
    }
    let cartArrayList =
      filteredPeople &&
      filteredPeople.length > 0 &&
      filteredPeople[0].cartArray;
    this.updateTotalAmounts(cartArrayList);
    const taxRate = 2500;
    let grossTotalAmountSum = 0;
    let totalTaxAmount = 0;

    const formattedItems = cartArrayList.map((item) => {
      const unitPrice = item.price * 100; // Convert price to cents (e.g., 1499 → 149900)
      const taxAmount = Math.round(
        item.quantity * unitPrice * (taxRate / 10000)
      ); // 25% tax
      const netTotalAmount = item.quantity * unitPrice; // Net total before tax
      const grossTotalAmount = netTotalAmount + taxAmount; // Final total including tax
      grossTotalAmountSum += grossTotalAmount;
      totalTaxAmount += taxAmount;

      let text1SwedishText = item.text1
        .replace(
          TranslationFile.netsPaymentDoItYourself["en"].trim(),
          TranslationFile.netsPaymentDoItYourself[userSelectedLanguage].trim()
        )
        .replace(
          TranslationFile.netsPaymentAnnualReport["en"].trim(),
          TranslationFile.netsPaymentAnnualReport[userSelectedLanguage].trim()
        )
        .replace(
          TranslationFile.netsPaymentAccountingCompanyUnlimited["en"].trim(),
          TranslationFile.netsPaymentAccountingCompanyUnlimited[
            userSelectedLanguage
          ].trim()
        )
        .replace(
          TranslationFile.netsPaymentAccountingCompany["en"].trim(),
          TranslationFile.netsPaymentAccountingCompany[
            userSelectedLanguage
          ].trim()
        )
        .replace(
          TranslationFile.netsPaymentAccountingCompanyPackage["en"].trim(),
          TranslationFile.netsPaymentAccountingCompanyPackage[
            userSelectedLanguage
          ].trim()
        );

      let text2SwedishText = item.text2
        .replace(
          TranslationFile.netsPaymentDoItYourself["en"].trim(),
          TranslationFile.netsPaymentDoItYourself[userSelectedLanguage].trim()
        )

        .replace(
          TranslationFile.netsPaymentUnlimitedAnnualReports["en"].trim(),
          TranslationFile.netsPaymentUnlimitedAnnualReports[
            userSelectedLanguage
          ].trim()
        )
        .replace(
          TranslationFile.netsPaymentAnnualReport["en"].trim(),
          TranslationFile.netsPaymentAnnualReport[userSelectedLanguage].trim()
        )
        .replace(
          TranslationFile.netsPaymentAccountingCompanyPackage["en"].trim(),
          TranslationFile.netsPaymentAccountingCompanyPackage[
            userSelectedLanguage
          ].trim()
        );
      return {
        reference: text2SwedishText, // Using `text1` as reference
        name: text1SwedishText, // Name of the package
        quantity: item.quantity, // Quantity of the package
        unit: "pcs", // Default unit
        unitPrice: unitPrice, // Price in cents
        taxRate: taxRate, // Tax rate
        taxAmount: taxAmount, // Calculated tax amount
        netTotalAmount: netTotalAmount, // Net amount before tax
        grossTotalAmount: grossTotalAmount, // Final amount after tax
        packageId: item.packageId,
        isOfferItem: false
      };
    });

    let offerId = 0;

    if (
      discountResponse != null &&
      gDiscountErrorResponseStatus != null &&
      discountResponse.offerId > 0
    ) {
      let discAmount;
      offerId = discountResponse.offerId;
      let discountValue;

      if (discountResponse.discountType == "Percentage") {
        discountValue = Number(discountResponse.discountValue.split("%")[0]);
      } else {
        discountValue = Number(discountResponse.discountValue.split("")[0]);
      }

      discAmount = (grossTotalAmountSum * discountValue) / 100;
      discAmount = Math.round(discAmount);

      let discountNegativeAmount = discAmount * -1;

      let discountTaxAmount = Math.round(
        (discountNegativeAmount * 2500) / (10000 + 2500)
      );

      let discountNetTotalAmount = discountNegativeAmount - discountTaxAmount;

      let discountObj = {
        reference: discountResponse.couponDescription, // Using `text1` as reference
        name: "Rabatt", // Name of the package
        quantity: 1, // Quantity of the package
        unit: "pcs", // Default unit
        unitPrice: discAmount * -1, // Price in cents
        taxRate: 2500, // Tax rate
        taxAmount: discountTaxAmount, // Calculated tax amount
        netTotalAmount: discountNetTotalAmount, // Net amount before tax
        grossTotalAmount: discountNegativeAmount, // Final amount after tax
        packageId: discountResponse.offerId,
        isOfferItem: true
      };

      formattedItems.push(discountObj);
    }

    let totalAmount = formattedItems.reduce(
      (sum, item) => sum + item.grossTotalAmount,
      0
    );

    if (type == "create") {
      const {
        billingType,
        emailId,
        name,
        lastName,
        companyName,
        countryCode,
        contactNumber,
        billingAddress,
        careOf
      } = this.state;

      const consumerData = {
        email: emailId
      };

      if (
        billingType === "Private" ||
        billingType === TranslationFile.loginPrivateText[userSelectedLanguage]
      ) {
        consumerData.privatePerson = {
          firstName: name,
          lastName
        };
      } else if (
        billingType === "Company" ||
        billingType === TranslationFile.netsPaymentCompany[userSelectedLanguage]
      ) {
        consumerData.company = {
          name: companyName,
          contact: {
            firstName: name,
            lastName
          }
        };
      }
      if (
        countryCode &&
        contactNumber &&
        countryCode.trim() !== "" &&
        contactNumber.trim() !== ""
      ) {
        consumerData.phoneNumber = {
          prefix: countryCode,
          number: contactNumber
        };
      }

      if (
        billingAddress &&
        billingAddress.trim() !== "" &&
        postalCode &&
        // postalCode.trim() !== "" &&
        city &&
        city.trim() !== ""
      ) {
        const billingAddressObj = {
          addressLine1: billingAddress,
          postalCode,
          city,
          country: "SWE"
        };

        if (careOf && careOf.trim() !== "") {
          billingAddressObj.addressLine2 = careOf;
        }

        consumerData.billingAddress = billingAddressObj;
      }

      const paymentData = {
        guid: gCurrentReportGUIDFromUrl,
        application: "Annual Report",
        offerId: offerId,
        order: {
          items: formattedItems,
          amount: totalAmount,
          currency: "SEK",
          reference: "RebelSkool AB"
        },
        checkout: {
          termsUrl: config.backend.url + "terms",
          publicDevice: false,
          charge: true,
          integrationType: "EmbeddedCheckout",
          merchantHandlesConsumerData: true,
          appearance: {
            displayOptions: {
              showMerchantName: true,
              showOrderSummary: true
            }
          },
          consumer: consumerData,
          countryCode: "SWE",

          consumerType: {
            supportedTypes: ["B2C"],
            default: "B2C"
          },
          url:
            config.annualReport.url +
            "/" +
            gCurrentReportGUIDFromUrl +
            "/payment"
        },
        notifications: {
          webHooks: [
            {
              eventName: "payment.created",
              url: config.backend.url + "webhook",
              authorization: "myAuthorizationKey"
            },
            {
              eventName: "payment.checkout.completed",
              url: config.backend.url + "webhook",
              authorization: "myAuthorizationKey"
            }
          ]
        },
        paymentMethodsConfiguration: [
          { name: "Invoice" },
          { name: "Visa" },
          { name: "MasterCard" },
          { name: "AmericanExpress" },
          { name: "Swish" },
          { name: "PayPal" },
          { name: "Klarna" },
          { name: "Trustly" }
        ],
        myReference: "RBLCheckoutId",
        additionalPaymentMethodData: {
          Riverty: { OrderReference: "RBLCheckoutId" },
          PayPal: { OrderReference: "RBLCheckoutId" }
        }
      };
      this.createNetsPayment(paymentData, navToPaymentConfirmation);
    } else if (type == "update") {
      const updateData = {
        offerId: offerId,
        amount: totalAmount,
        items: formattedItems,
        shipping: {
          costSpecified: true
        }
      };
      setTimeout(() => {
        this.updateNetsPayment(updateData);
      }, 2000);
    }
  }

  createNetsPayment = async (paymentData, navToPaymentConfirmation) => {
    //testapi.rebelskool.com
    const {
      organizationNumber,
      companyName,
      postalCode,
      city,
      name,
      lastName,
      emailId,
      contactNumber,
      countryCode,
      careOf,
      billingAddress
    } = this.state;

    try {
      const response = await axios.post(
        config.backend.url + "nets/createCheckout",
        paymentData,
        {
          headers: {
            "Content-Type": "application/json",
            "User-Session-Auth-Key":
              userSessionAuthKeyReturnValue.headers["User-Session-Auth-Key"]
          }
        }
      );

      this.setState({ paymentId: response.data.paymentId });
      let address = "";
      if (careOf.trim() == "") {
        address = billingAddress;
      } else if (careOf.trim() != "" && billingAddress.trim() == "") {
        address = careOf;
      } else {
        address = careOf + ", " + billingAddress;
      }
      let billingInfo = {
        key: "all", /////
        value: "all",
        checkoutId: response.data.paymentId,
        companyName: companyName,
        registrationNo: organizationNumber,
        postalCode: postalCode,
        city: city,
        name: name,
        lastName: lastName,
        emailId: emailId,
        mobileNumber: this.state.countryCode + " " + this.state.contactNumber,
        address: address
      };

      axios
        .post(
          "/annualReportPackage/updatePaymentHeaderBillingInfo",
          billingInfo,
          userSessionAuthKeyReturnValue
        )
        .then((updateCompanyNumberResponse) => {
          if (navToPaymentConfirmation) {
            let navigationURL =
              "/annualreport/" +
              gCurrentReportGUIDFromUrl +
              "/paymentConfirmation";

            this.props.history.push(navigationURL);
          }
        });
    } catch (error) {
      console.error(
        "Error creating payment:",
        error.response ? error.response.data : error.message
      );
    }
  };

  updateNetsPayment = async (updateData) => {
    const { paymentId } = this.state;

    if (paymentId != null) {
      try {
        const response = await axios.put(
          config.backend.url + `nets/updateCheckout/${paymentId}`,
          updateData,
          {
            headers: {
              "Content-Type": "application/json",
              "User-Session-Auth-Key":
                userSessionAuthKeyReturnValue.headers["User-Session-Auth-Key"]
            }
          }
        );
        if ((response.data.response = "No Content")) {
          this.setState({
            rerender: true,
            iframeKey: this.state.iframeKey + 1
          });
        }
      } catch (error) {
        console.error(
          "Error updating checkout:",
          error.response ? error.response.data : error.message
        );
      }
    }
  };

  // createPaysonCheckout() {
  //   const { login, payment } = this.props;
  //   const {paymentId} = this.state;

  //   const {
  //     registrationNoFromDB,
  //     organizationNumber,
  //     accountingCompanyOrgName,
  //     companyNameFromDB,
  //     companyName,
  //     accountingCompanyPostalCode,
  //     postalCodeFromDB,
  //     postalCode,
  //     accountingCompanyCity,
  //     cityFromDB,
  //     city,
  //   } = this.state;
  //   cartValuesLocalData = JSON.parse(localStorage.getItem("cartValues"));
  //   if (cartValuesLocalData == null) {
  //     cartValuesLocalData = [];
  //   }
  //   let filteredPeople = [];
  //   if (login != undefined) {
  //     filteredPeople =
  //       cartValuesLocalData &&
  //       cartValuesLocalData.filter((item) => item.userID == login.userID);
  //   }
  //   let cartArrayList =
  //     filteredPeople &&
  //     filteredPeople.length > 0 &&
  //     filteredPeople[0].cartArray;
  //   itemsForPostPayson = [];

  //   let itemsObject = {
  //     name: "",
  //     unitPrice: 0,
  //     quantity: 0,
  //     taxRate: 0.25,
  //   };
  //   let totalSumIncludingMoms = 0;
  //   cartArrayList &&
  //     cartArrayList.length &&
  //     cartArrayList.map((val) => {
  //       let itemsObject = {
  //         name: val.text1,
  //         packageDetailsName: val.packageName,
  //         packageId: val.packageId,
  //         accountingCompanyId: Math.round(
  //           login.isAccountingCompany == true ? 1 : 0
  //         ),
  //         unitPrice: val.price + (val.price * 25) / 100,
  //         quantity: val.quantity,
  //         taxRate: 0,
  //         status: 1,
  //         maxUsage: val.maxUsage * val.quantity,
  //         actualUsage: 0,
  //         type: "service",
  //       };

  //       totalSumIncludingMoms =
  //         totalSumIncludingMoms + itemsObject.quantity * itemsObject.unitPrice;
  //       itemsForPostPayson.push(itemsObject);
  //     });

  //   const annualReport = "/annualreport/";

  //   let createCheckout = {
  //     application: "Annual Report",
  //     userId: login.userID,
  //     guid: gCurrentReportGUIDFromUrl,
  //     merchant: {
  //       checkoutUri: "https://www.examplestore.com/checkout.php",
  //       confirmationUri: navigationUrl,
  //       // notificationUri: "https://www.examplestore.com/notification.php",
  //       notificationUri:
  //         config.annualReport.url +
  //         "/notification?checkout=" +
  //         gCurrentReportGUIDFromUrl,
  //       termsUri: "https://www.examplestore.com/terms.php",
  //     },
  //     order: {
  //       currency: "sek",
  //       items: itemsForPostPayson,
  //     },
  //   };

  //   axios
  //     .post(
  //       "/annualReportPackage/paysonCreateCheckout",
  //       createCheckout,
  //       userSessionAuthKeyReturnValue
  //     )
  //     .then((response) => {
  //       if (response.data) {
  //         paysonIDFromResponse = response.data.id;
  //         payment.values.checkoutRef = paysonIDFromResponse;
  //         iFrameID =
  //           "https://test-www.payson.se/embedded/checkout?id=" +
  //           paysonIDFromResponse;
  //         // this.updatePaysonCheckout();

  //         let billingInfo = {
  //           key: "all",
  //           value: "all",
  //           checkoutId: paymentId,
  //           // companyName: this.state.companyName,
  //           companyName: companyName,
  //           // login && login.isAccountingCompany
  //           //   ? accountingCompanyOrgName
  //           //   : companyName != undefined && companyName != ""
  //           //   ? companyName
  //           //   : companyNameFromDB,
  //           // registrationNo: this.state.organizationNumber,
  //           registrationNo: organizationNumber,
  //           // login && login.isAccountingCompany
  //           //   ? login.accountingCompanyRegNo
  //           //   : registrationNoFromDB != "" && registrationNoFromDB != null
  //           //   ? registrationNoFromDB
  //           //   : organizationNumber,
  //           // postalCode: this.state.postalCode,
  //           postalCode: postalCode,
  //           // login && login.isAccountingCompany
  //           //   ? accountingCompanyPostalCode
  //           //   : postalCodeFromDB != "" && postalCodeFromDB != null
  //           //   ? postalCodeFromDB
  //           //   : postalCode,
  //           // city: this.state.city,
  //           city: city,
  //           // login && login.isAccountingCompany
  //           //   ? accountingCompanyCity
  //           //   : cityFromDB != "" && cityFromDB != null
  //           //   ? cityFromDB
  //           //   : city,
  //           name: login.userName,
  //           lastName: login.lastName,
  //           emailId: login.emailID,
  //           // mobileNumber:
  //           //     this.state.countryCode + " " + this.state.contactNumber,
  //         };

  //         axios
  //           .post(
  //             "/annualReportPackage/updatePaymentHeaderBillingInfo",
  //             billingInfo,
  //             userSessionAuthKeyReturnValue
  //           )
  //           .then((updateCompanyNumberResponse) => { });
  //       }

  //       this.setState({
  //         rerender: true,
  //         iframeKey: this.state.iframeKey + 1,
  //       });
  //     });
  // }

  carouselButton(selectedCart) {
    const { discountInput, totalPriceIncMoms, totalPriceExcMoms } = this.state;
    const { login, prices } = this.props;
    cartValuesLocalData = JSON.parse(localStorage.getItem("cartValues") || []);
    let filteredPeople = [];

    const upd_cartValuesLocalData = cartValuesLocalData.map((obj) => {
      let cartArray = obj.cartArray;
      filteredPeople = cartArray.filter(
        (item) => item.packageId == selectedCart.packageId
      );

      if (filteredPeople.length > 0) {
        cartArray.map((i, idx) => {
          if (i.packageId == selectedCart.packageId) {
            i.quantity = i.quantity + 1;
          }
          return i;
        });

        gridData = obj.cartArray;
        gridData =
          gridData &&
          gridData.filter((val) => val.application == "Annual Report");
      } else {
        selectedCart.quantity = 1;
        cartArray.push(selectedCart);
        gridData = cartArray;
        gridData =
          gridData &&
          gridData.filter((val) => val.application == "Annual Report");
      }
      return obj;
    });

    localStorage.setItem("cartValues", JSON.stringify(upd_cartValuesLocalData));

    if (null != discountInput) {
      let removeEmptySpaces = discountInput.replace(/\s+/g, "");

      let config = setUserSessionAuthKey();
      let totalPrice = totalPriceExcMoms.replace(",", ".");
      totalPrice = Number(totalPrice.replace(/\s+/g, ""));

      let qty;

      if (selectedCart.quantity != undefined) {
        qty = selectedCart.quantity;
      } else qty = selectedCart.maxUsage;

      totalPrice = totalPrice + selectedCart.price * qty;

      if (
        removeEmptySpaces.length > 0 &&
        userSessionAuthKeyReturnValue &&
        config
      ) {
        config.params = {
          totalAmount: totalPrice,
          couponCode: discountInput
        };

        axios
          .get("/RBLOffer/ApplyOffer", config)
          .then((response) => {
            this.setState({
              discountResponse: response.data,
              discountErrorResponseStatus: false
            });

            gDiscountErrorResponseStatus = false;
          })
          .catch((error) => {
            this.setState({
              discountResponse: error.response,
              discountErrorResponseStatus: true
            });
          });
      }
    }

    // this.updatePaysonCheckout();
    this.createPaymentData("update", false);
  }

  billingTypeTabOnChange(type) {
    this.setState({ billingType: type });
  }

  packageCarouselRender(item) {
    return (
      <div>
        <div class="col-md-4 col-sm-6" className="pricesIterationDiv">
          <div class="paymentPricingTable">
            <div class="paymentPricingTable-header">
              {/* <span class="heading">{item.title}</span> */}
              {/* <span>{item.text1}</span> */}
              {(item.packageId == 200 || item.packageId == 500) && (
                <div className="payment-carousel-recommended-tag">
                  {TranslationFile.recommended[userSelectedLanguage]}
                </div>
              )}
              <span>
                {" "}
                {TranslationPackageInfo[item.text1]
                  ? TranslationPackageInfo[item.text1][userSelectedLanguage]
                  : item.text1}
              </span>
            </div>
            <div class="pricing-plans">
              <span class="price-value">
                <span>{numberWithSpace(item.price)} kr</span>
              </span>
            </div>
            <div class="pricingContent">
              <ul>
                <li>{item.packageName}</li>
                {/* <li>validity : {item.validityPeriod}</li> */}
                <li>
                  {TranslationFile.ValidityText[userSelectedLanguage]} :{" "}
                  {TranslationPackageInfo[item.validityPeriod]
                    ? TranslationPackageInfo[item.validityPeriod][
                        userSelectedLanguage
                      ]
                    : item.validityPeriod}
                </li>
                {/* <li>{item.text3}</li> */}
                <li>
                  {TranslationPackageInfo[item.text3]
                    ? TranslationPackageInfo[item.text3][userSelectedLanguage]
                    : item.text3}
                </li>
              </ul>
            </div>

            <div class="pricingTable-sign-up">
              <button
                onClick={() => this.carouselButton(item)}
                class="btn btn-block btn-default"
              >
                <i
                  className="pi pi-shopping-cart"
                  style={{ fontSize: "1rem", padding: "4px" }}
                ></i>
                {TranslationFile.priceAddCart[userSelectedLanguage]}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // orgNoOnBlur(e) {
  //   const { login } = this.props;
  //   const { paymentId } = this.state;

  //   if (userSessionAuthKeyReturnValue) {
  //     let billingInfo = {
  //       key: "registrationNo",
  //       value: e.target.value,
  //       userId: login.userID,
  //       checkoutId: paymentId,
  //     };

  //     //Update Billing Info API
  //     axios
  //       .post(
  //         "/annualReportPackage/updatePaymentHeaderBillingInfo",
  //         billingInfo,
  //         userSessionAuthKeyReturnValue
  //       )
  //       .then((response) => {});
  //   }
  // }

  updateGridDataNameColumn(gridData) {
    // gridData &&
    //   gridData.length &&
    //   gridData.map((i, idx) => {
    //     return (i.title = i.text1
    //       // + " - " + i.packageName
    //     );
    //   });
    if (gridData && gridData.length) {
      gridData.forEach((item) => {
        const translation = TranslationPackageInfo[item.text1];
        if (translation) {
          item.title = translation[userSelectedLanguage] || item.text1; // fallback if language key missing
        } else {
          item.title = item.text1; // fallback if text1 not found in JSON
        }
      });
    }
  }

  convertDateFormat(startingEpochValue, validUntilEpochValue) {
    let startingDateValue = moment.unix(startingEpochValue) / 1000;
    let validDateValue = moment.unix(validUntilEpochValue) / 1000;

    let startingDateValueFormat =
      moment(startingDateValue).format("YYYY-MM-DD");

    let validDateValueFormat = moment(validDateValue).format("YYYY-MM-DD");
    return { startingDateValueFormat, validDateValueFormat };
  }

  packageNameBodyTemplate(rowData, rowIndex) {
    if (rowIndex.rowIndex == 0) {
      return (
        <div style={{ color: "black", fontWeight: "700" }}>
          {rowData.packageName}
        </div>
      );
    } else {
      return <div style={{ color: "grey" }}>{rowData.packageName}</div>;
    }
  }
  quantityLevelBodyTemplate(rowData, rowIndex) {
    if (rowIndex.rowIndex == 0) {
      return (
        <div style={{ color: "black", fontWeight: "700", textAlign: "center" }}>
          {rowData.quantity}
        </div>
      );
    } else {
      return (
        <div style={{ color: "grey", textAlign: "center" }}>
          {rowData.quantity}
        </div>
      );
    }
  }
  startingDateBodyTemplate(rowData, rowIndex) {
    let dateOnly = rowData.startingDate.slice(0, 10);
    if (rowIndex.rowIndex == 0) {
      return (
        <div style={{ color: "black", fontWeight: "700" }}>{dateOnly}</div>
      );
    } else {
      return <div style={{ color: "grey" }}>{dateOnly}</div>;
    }
  }
  validUntilBodyTemplate(rowData, rowIndex) {
    let dateOnly = rowData.validUntil.slice(0, 10);
    if (rowIndex.rowIndex == 0) {
      return (
        <div style={{ color: "black", fontWeight: "700" }}>{dateOnly}</div>
      );
    } else {
      return <div style={{ color: "grey" }}>{dateOnly}</div>;
    }
  }
  maxUsageBodyTemplate(rowData, rowIndex) {
    if (rowIndex.rowIndex == 0) {
      return (
        <div style={{ color: "black", fontWeight: "700", textAlign: "center" }}>
          {rowData.maxUsage}
        </div>
      );
    } else {
      return (
        <div style={{ color: "grey", textAlign: "center" }}>
          {rowData.maxUsage}
        </div>
      );
    }
  }
  actualUsageBodyTemplate(rowData, rowIndex) {
    if (rowIndex.rowIndex == 0) {
      return (
        <div style={{ color: "black", fontWeight: "700", textAlign: "center" }}>
          {rowData.actualUsage}
        </div>
      );
    } else {
      return (
        <div style={{ color: "grey", textAlign: "center" }}>
          {rowData.actualUsage}
        </div>
      );
    }
  }

  remainingReportsBodyTemplate(rowData, rowIndex) {
    if (rowIndex.rowIndex == 0) {
      return (
        <div style={{ color: "black", fontWeight: "700", textAlign: "center" }}>
          {rowData.maxUsage - rowData.actualUsage}
        </div>
      );
    } else {
      return (
        <div style={{ color: "grey", textAlign: "center" }}>
          {rowData.maxUsage - rowData.actualUsage}
        </div>
      );
    }
  }

  finalPayForCurrentReport() {
    const { headerTableData } = this.state;
    this.setState({ payBtnEnable: true });
    if (userSessionAuthKeyReturnValue) {
      let splittedUrl = window.location.href.split("/");
      gCurrentReportGUIDFromUrl = splittedUrl[splittedUrl.length - 2];
      let payCurrentReport = {
        entryNo: previouslyBoughtPackages[0].entryNo,
        reportGUID: gCurrentReportGUIDFromUrl
      };

      axios
        .post(
          "/annualReportPackage/payNow",
          payCurrentReport,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          if (response.data) {
            this.setState({ showPaidDialogBox: true });
            this.toast.show({
              severity: "success",
              summary: "Navigating to Review and Send",
              detail: "Package used for Report. Navigation to Review the PDF",
              life: 3000
            });
            setTimeout(() => {
              this.navigateAfterPayment();
            }, 2000);
          }
          // this.setState({ payBtnEnable: false });
        });
    }
  }
  checkUpdatedBillingInfo() {
    const {
      companyName,
      organizationNumber,
      companyNameFromDB,
      registrationNoFromDB,
      postalCodeFromDB,
      cityFromDB,
      postalCode,
      city,
      name,
      emailId
    } = this.state;
    const { login } = this.props;
    if (login && login.accountingCompany == false) {
      //Private Company
      // if (
      //   ((registrationNoFromDB != "" && registrationNoFromDB != null) ||
      //     (organizationNumber != "" && organizationNumber != null)) &&
      //   ((companyName != "" && companyName != null) ||
      //     (companyNameFromDB != "" && companyNameFromDB != null)) &&
      //   ((postalCodeFromDB != "" && postalCodeFromDB != null) ||
      //     (postalCode != "" && postalCode != null)) &&
      //   ((cityFromDB != "" && cityFromDB != null) ||
      //     (city != "" && city != null))
      // )
      if (name != "" && name != null && emailId != "" && emailId != null) {
        billingInfoUpdated = false;
      } else {
        billingInfoUpdated = true;
      }
    }
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    const { login, prices, currentPageName, sideBarReducer, payment } =
      this.props;

    // Initial log
    // console.log("Initial width:", window.innerWidth);

    // Listen to resize
    window.addEventListener("resize", this.handleResize);

    userSelectedLanguage = localStorage.getItem("selectedLanguage");
    currentPageName.values = "Payment";
    localStorage.setItem("currentPageName", "Payment");

    this.billingTypeOptions = [
      TranslationFile.loginPrivateText[userSelectedLanguage],
      TranslationFile.netsPaymentCompany[userSelectedLanguage]
    ];

    this.setState({
      billingType: this.billingTypeOptions[1]
    });

    let splittedUrl = window.location.href.split("/");
    gCurrentReportGUIDFromUrl = splittedUrl.includes("#prices")
      ? localStorage.getItem("sessionUUID")
      : splittedUrl[splittedUrl.length - 2];
    console.log("gCurrentReportGUIDFromUrl", gCurrentReportGUIDFromUrl);
    rebelSkoolUserLSParse = JSON.parse(localStorage.getItem("rebelSkoolUser"));
    let cartArrayList = [];
    if (userSessionAuthKeyReturnValue) {
      if (login != undefined) {
        cartValuesLocalData =
          localStorage.getItem("cartValues") &&
          JSON.parse(localStorage.getItem("cartValues"));
        if (cartValuesLocalData == null) {
          cartValuesLocalData = [];
        }
        let filteredPeople = [];
        filteredPeople =
          cartValuesLocalData &&
          cartValuesLocalData.filter((item) => item.userID == login.userID);

        cartArrayList =
          filteredPeople &&
          filteredPeople.length > 0 &&
          filteredPeople[0].cartArray;

        this.updateTotalAmounts(cartArrayList);

        // From Reducer
        this.setState({
          emailId: login.emailID,
          name: login.userName,
          lastName: login.lastName
        });

        payment.values.name = login.userName;
        payment.values.emailId = login.emailID;
      }
      axios
        .get(
          "/annualReport/getHeader?reportId=" + gCurrentReportGUIDFromUrl,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          annualReportHeaderAPIResp = response.data;
          if (annualReportHeaderAPIResp != "") {
            //If he has a record in Annual Report Header Table
            this.setState({ headerTableData: response.data });
            //Check the Access status of the user accessing the report
            //If the user is private
            if (annualReportHeaderAPIResp.reportID != null) {
              this.setState({ reportPaymentCheckout: true });

              this.setState({
                name: rebelSkoolUserLSParse.firstName,
                lastName: rebelSkoolUserLSParse.lastName,
                organizationNumber: annualReportHeaderAPIResp.registrationNo,
                companyName: annualReportHeaderAPIResp.companyName,
                postalCode: annualReportHeaderAPIResp.postalCode,
                city: annualReportHeaderAPIResp.city,
                accountingCompanyPostalCode:
                  annualReportHeaderAPIResp.postalCode,
                accountingCompanyCity: annualReportHeaderAPIResp.city
              });

              let reportAccessReq = {
                reportId: annualReportHeaderAPIResp.reportID
              };

              axios
                .post(
                  "/annualReport/getAccessStatus",
                  reportAccessReq,
                  userSessionAuthKeyReturnValue
                )
                .then((response) => {
                  if (response.data) {
                    if (response.data == 1) {
                      showPayment = true;
                    }
                    // else {
                    //   showPayment = false;
                    // }

                    this.setState({
                      accessLevel: response.data
                    });
                  }
                })
                .catch((error) => {
                  this.setState({
                    accessLevel: error.response.data
                  });
                });

              if (!rebelSkoolUserLSParse.isAccountingCompany) {
                this.setState({
                  annualReportID: annualReportHeaderAPIResp.reportID
                });
              }

              // If the user is from a Accounting company - Admin/User
              else {
                let reportGUID = {
                  reportGUID: gCurrentReportGUIDFromUrl
                };
                showPayment = true;
                // axios
                //   .post(
                //     "/annualReport/getReportOwnerAccountingCompanyId",
                //     reportGUID,
                //     userSessionAuthKeyReturnValue
                //   )
                //   .then((response) => {
                //     if (response.data) {
                //       showPayment = true;
                //     } else {
                //       showPayment = false;
                //     }
                //   });
              }
            }
            // This is to determine whether the user is paying after completing the record or
            // he is paying from the home page clicking Go To CheckOut
            if (
              annualReportHeaderAPIResp != "" &&
              annualReportHeaderAPIResp.reportID != null
            ) {
              navigationUrl =
                config.annualReport.url +
                "/" +
                gCurrentReportGUIDFromUrl +
                // "/reviewAndSend";
                "/paymentConfirmation";

              //Get the completed pages for this report for the green tick in the sidebar
              axios
                .get(
                  "/annualReport/getCompletedPages?reportId=" +
                    annualReportHeaderAPIResp.reportID,
                  userSessionAuthKeyReturnValue
                )
                .then((completedStatementTypesResponse) => {
                  sideBarReducer.values = completedStatementTypesResponse.data;
                  sideBarGreenTickPages = completedStatementTypesResponse.data;

                  sideBarGreenTickPages = [...new Set(sideBarGreenTickPages)];
                  let updatePossibleNavigationPagesListString = JSON.stringify(
                    sideBarGreenTickPages
                  );
                  localStorage.setItem(
                    "possibleAccessablePages",
                    updatePossibleNavigationPagesListString
                  );

                  this.setState({
                    reRender: true
                  });
                });
            } else {
              let possibleAccessablePagesListLSString = localStorage.getItem(
                "possibleAccessablePages"
              );

              let possibleAccessablePagesListLSArray = JSON.parse(
                possibleAccessablePagesListLSString
              );

              navigationUrl =
                config.annualReport.url +
                "/" +
                gCurrentReportGUIDFromUrl +
                // "/MyProfile";
                "/paymentConfirmation";
            }

            this.setState({
              paymentEntryNo: annualReportHeaderAPIResp.paymentEntryNo
            });

            if (annualReportHeaderAPIResp.registrationNo != "")
              this.setState({
                registrationNoFromDB: annualReportHeaderAPIResp.registrationNo
              });

            if (annualReportHeaderAPIResp.companyName != "") {
              this.setState({
                companyNameFromDB: annualReportHeaderAPIResp.companyName
              });
            }

            if (annualReportHeaderAPIResp.postalCode != "")
              this.setState({
                postalCodeFromDB: annualReportHeaderAPIResp.postalCode
              });

            if (annualReportHeaderAPIResp.city != "")
              this.setState({
                cityFromDB: annualReportHeaderAPIResp.city
              });

            if (annualReportHeaderAPIResp.currentYear != "")
              this.setState({
                currentFinancialYear: annualReportHeaderAPIResp.currentYear
              });

            // Check if he has already bought packages
            axios
              .get(
                "/annualReportPackage/getPaymentLines",
                userSessionAuthKeyReturnValue
              )
              .then((response) => {
                if (response.data) {
                  previouslyBoughtPackages = response.data;
                  previouslyBoughtPackages = previouslyBoughtPackages.filter(
                    (pack) => pack.status == true
                  );

                  if (
                    previouslyBoughtPackages.length > 0 &&
                    annualReportHeaderAPIResp.reportID != null
                  ) {
                    this.setState({ activePackageAvailable: true });
                  }
                }

                axios.get("/siteOwner/getTemplatePackages").then((response) => {
                  if (response.data.length > 0) {
                    let paymentPackagesTable = response.data;
                    paymentPackagesTable = paymentPackagesTable.filter(
                      (val) => val.application == "Annual Report"
                    );

                    if (
                      (!cartArrayList || cartArrayList.length == 0) &&
                      previouslyBoughtPackages.length <= 0
                    ) {
                      this.settingDefaultCartValue(response.data);
                    } else {
                      gridData = cartArrayList;
                      gridData =
                        gridData &&
                        gridData.filter(
                          (val) => val.application == "Annual Report"
                        );
                    }
                    if (login) {
                      // carouselData = response.data;
                      carouselData = paymentPackagesTable;
                    }
                    this.setState({
                      // pricesList: response.data,
                      pricesList: paymentPackagesTable
                    });
                  }
                });
                this.setState({ isLoading: false });

                //If he has no exisiting packages, We need to getPaysonCheckOut
                if (
                  (previouslyBoughtPackages.length <= 0 ||
                    annualReportHeaderAPIResp.reportID == null) &&
                  this.state.paymentEntryNo <= 0
                ) {
                  const config = {
                    headers: {
                      "User-Session-Auth-Key":
                        userSessionAuthKeyReturnValue.headers[
                          "User-Session-Auth-Key"
                        ],
                      language: userSelectedLanguage
                    }
                  };
                  axios
                    .get(
                      "/nets/getCheckout?reportGUID=" +
                        gCurrentReportGUIDFromUrl,
                      config
                    )
                    .then((response) => {
                      let respData = response.data;
                      if (
                        respData != "" &&
                        respData.paymentStatus == "shipped"
                      ) {
                        this.toast.show({
                          severity: "success",
                          summary: "Payment Successfully Completed",
                          detail:
                            "We received your Payment. Navigating to Payment Confirmation",
                          life: 2000
                        });

                        this.setState({ isLoading: false });
                        let navigationUrl =
                          // config.annualReport.url +
                          "/annualreport/" +
                          gCurrentReportGUIDFromUrl +
                          "/paymentConfirmation";
                        setTimeout(() => {
                          this.props.history.push(navigationUrl);
                        }, 2000);
                      }

                      if (response.data == "") {
                        // this.createPaymentData('create');
                      } else {
                        this.setState({ isLoading: false });

                        this.setState({
                          paymentId: response.data.pspCheckoutRef
                        });
                        if (respData.mobileNumber != "") {
                          let mobileNoSplit = respData.mobileNumber.split(" ");
                          this.setState({
                            countryCode: mobileNoSplit[0],
                            contactNumber: mobileNoSplit[1]
                          });
                        }
                        this.setState({
                          city: response.data.city,
                          companyName: response.data.companyName,
                          emailId: response.data.emailId,
                          name: response.data.firstName,
                          lastName: response.data.lastName,
                          postalCode: response.data.postalCode,
                          organizationNumber: response.data.registrationNo
                        });
                        this.createPaymentData("update", false);
                        this.setState({
                          rerender: true,
                          iframeKey: this.state.iframeKey + 1,
                          showPaymentIframe: true,
                          showPaymentAccordion: true,
                          billingInfoEdit: true
                        });
                      }

                      // if(response.data.paymentStatus != null) {

                      // if (response.data.address != null) {
                      //   let addressArray = response.data.address.split("$$$");
                      //   if (addressArray.length == 1) {
                      //     this.setState({
                      //       billingAddress: addressArray[0],
                      //     });
                      //   } else {
                      //     this.setState({
                      //       careOf: addressArray[0],
                      //       billingAddress: addressArray[1],
                      //     });
                      //   }
                      // }

                      // if (response.firstName != null) {
                      //   this.setState({
                      //     name: response.data.firstName,
                      //   });
                      // } else {
                      //   this.setState({
                      //     name: currentUserDetails.firstName,
                      //   });
                      // }

                      // if (response.firstName != null) {
                      //   this.setState({
                      //     lastName: response.data.lastName,
                      //   });
                      // } else {
                      //   this.setState({
                      //     lastName: currentUserDetails.lastName,
                      //   });
                      // }
                      // if (response.data.registrationNo != null) {
                      //   this.setState({
                      //     organizationNumber: response.data.registrationNo,
                      //   });
                      // }

                      // if (response.data.city != null) {
                      //   this.setState({
                      //     city: response.data.city,
                      //   });
                      // }

                      // if (response.data.companyName != null) {
                      //   this.setState({
                      //     companyName: response.data.companyName,
                      //   });
                      // }

                      // if (
                      //   response.data.postalCode != null &&
                      //   response.data.postalCode > 0
                      // ) {
                      //   this.setState({
                      //     postalCode: response.data.postalCode,
                      //   });
                      // }

                      // if (
                      //   response.data.paymentStatus == "readyToShip" ||
                      //   response.data.paymentStatus == "shipped"
                      // ) {
                      //   this.toast.show({
                      //     severity: "success",
                      //     summary: "Payment Successfully Completed",
                      //     detail:
                      //       "We received your Payment. Navigating to Payment Confirmation",
                      //     life: 2000,
                      //   });
                      //   let navigationUrl =
                      //     // config.annualReport.url +
                      //     "/annualreport/" +
                      //     gCurrentReportGUIDFromUrl +
                      //     "/paymentConfirmation";
                      //   setTimeout(() => {
                      //     this.props.history.push(navigationUrl);
                      //   }, 2000);
                      // }
                      // //If the payment status is equal to created
                      // else if (response.data.paymentStatus == "created") {
                      //   paysonIDFromResponse = response.data.pspCheckoutRef;
                      //   payment.values.checkoutRef =
                      //     response.data.pspCheckoutRef;

                      //   //Update the Billing Info if he has Reg No/Company Name/Postal Code/City
                      //   if (
                      //     annualReportHeaderAPIResp.companyName != null &&
                      //     annualReportHeaderAPIResp.registrationNo != null &&
                      //     annualReportHeaderAPIResp.postalCode != null &&
                      //     annualReportHeaderAPIResp.city != null
                      //   ) {
                      //     let billingInfo = {
                      //       key: "all",
                      //       value: "all",
                      //       checkoutId: paysonIDFromResponse,
                      //       companyName: annualReportHeaderAPIResp.companyName,
                      //       registrationNo:
                      //         annualReportHeaderAPIResp.registrationNo,
                      //       postalCode: annualReportHeaderAPIResp.postalCode,
                      //       city: annualReportHeaderAPIResp.city,
                      //       name: login.userName,
                      //       lastName: login.lastName,
                      //       emailId: login.emailID,
                      //     };

                      //     axios
                      //       .post(
                      //         "/annualReportPackage/updatePaymentHeaderBillingInfo",
                      //         billingInfo,
                      //         userSessionAuthKeyReturnValue
                      //       )
                      //       .then((updateCompanyNumberResponse) => { });
                      //   } else {
                      //     let billingInfo = {
                      //       key: "all",
                      //       value: "all",
                      //       checkoutId: paysonIDFromResponse,
                      //       companyName: this.state.companyName,
                      //       registrationNo: this.state.organizationNumber,
                      //       postalCode: this.state.postalCode,
                      //       city: this.state.city,
                      //       name: login.userName,
                      //       lastName: login.lastName,
                      //       emailId: login.emailID,
                      //     };

                      //     axios
                      //       .post(
                      //         "/annualReportPackage/updatePaymentHeaderBillingInfo",
                      //         billingInfo,
                      //         userSessionAuthKeyReturnValue
                      //       )
                      //       .then((updateCompanyNumberResponse) => { });
                      //   }

                      //   //If the user refresh the page iFrameID and iframeKey will update once again and rerender
                      //   iFrameID =
                      //     "https://test-www.payson.se/embedded/checkout?id=" +
                      //     paysonIDFromResponse;
                      //   this.setState({
                      //     rerender: true,
                      //     iframeKey: this.state.iframeKey + 1,
                      //   });
                      // }
                      // //If the payment status is expired/cancelled/
                      // else if (
                      //   response.data.paymentStatus !== null &&
                      //   (response.data.paymentStatus == "cancelled" ||
                      //     response.data.paymentStatus == "expired")
                      // ) {
                      //   // this.toast.show({
                      //   //   severity: "error",
                      //   //   summary: "Session Expired",
                      //   //   detail:
                      //   //     "Your Payment Session is expired. Redirecting to Home",
                      //   //   life: 2000,
                      //   // });
                      //   // this.createPaysonCheckout();
                      //   this.createPaymentData('create');
                      //   // let reverseNavigationUrl = "/annualreport/";
                      //   // setTimeout(() => {
                      //   //   this.props.history.push(reverseNavigationUrl);
                      //   //   // this.props.history.push(config.annualReport.url);
                      //   // }, 3000);
                      // }
                      // //If the payment status is denied
                      // else if (
                      //   response.data.paymentStatus != null &&
                      //   response.data.paymentStatus == "denied"
                      // ) {
                      //   this.toast.show({
                      //     severity: "error",
                      //     summary: "Payment Denied",
                      //     detail:
                      //       "Your Payment is denied by Payson. Redirecting to Home",
                      //     life: 2000,
                      //   });
                      //   setTimeout(() => {
                      //     this.props.history.push(config.annualReport.url);
                      //   }, 3000);
                      // }
                      // //If the payment status is readyToShip/shipped, we need to call Create Payson Checkout API
                      // else {
                      //   // this.createPaysonCheckout();
                      //   this.createPaymentData('create');
                      // }
                      // this.setState({ rerender: true });
                      // // }
                    })
                    .catch((error) => {});
                }
              });
          }

          if (annualReportHeaderAPIResp.reportID == null) {
            let possibleNavigationPagesList = [
              "My Dashboard"
              // "Company Information",
            ];
            possibleNavigationPagesList = [
              ...new Set(possibleNavigationPagesList)
            ];
            let possibleNavigationPagesListString = JSON.stringify(
              possibleNavigationPagesList
            );
            localStorage.setItem(
              "possibleAccessablePages",
              possibleNavigationPagesListString
            );
          }
        });
    }

    tourGuidePages = localStorage.getItem("tourGuidePages");
    if (tourGuidePages != null) {
      tourGuidePages = JSON.parse(tourGuidePages);
      if (!tourGuidePages.includes(currentPageTourGuideName)) {
        tourGuidePages.push(currentPageTourGuideName);
      }
      localStorage.setItem("tourGuidePages", JSON.stringify(tourGuidePages));
    } else {
      let currentPageTourGuideArray = [];
      currentPageTourGuideArray.push(currentPageTourGuideName);
      localStorage.setItem(
        "tourGuidePages",
        JSON.stringify(currentPageTourGuideArray)
      );
    }
  }
  navigateAfterPayment() {
    const annualReport = "/annualreport/";
    let navigationURL =
      annualReport + gCurrentReportGUIDFromUrl + "/reviewAndSend";
    this.props.history.push(navigationURL);
  }

  async navigateToPaymentConfirmation() {
    let userGUID = "";
    if (rebelSkoolUserLSParse && rebelSkoolUserLSParse.userGUID) {
      userGUID = rebelSkoolUserLSParse.userGUID;
      await this.createPaymentData("create", true);
    } else {
    }
  }
  nextPage = () => {
    const annualReport = "/annualreport/";
    let navigationURL =
      annualReport + gCurrentReportGUIDFromUrl + "/reviewAndSend";
    this.props.history.push(navigationURL);
  };

  navigateToReviewPage = async (discountResponse) => {
    const annualReport = "/annualreport/";
    let navigationURL =
      annualReport + gCurrentReportGUIDFromUrl + "/reviewAndSend";

    this.createPaymentData("create", true);
    this.props.history.push(navigationURL);
  };

  billingAddressOnChange(e, field) {
    if (field == "CO") {
      this.setState({
        careOf: e.target.value
      });
      this.setState({
        invalidFields: Object.assign({}, this.state.invalidFields, {
          careOf: false
        })
      });
    } else {
      this.setState({
        billingAddress: e.target.value
      });
      this.setState({
        invalidFields: Object.assign({}, this.state.invalidFields, {
          billingAddress: false
        })
      });
    }
  }

  // billingAddressOnBlur(e, field) {
  //   const { careOf, billingAddress, paymentId } = this.state;
  //   let addressLine = "";
  //   if (careOf != undefined && careOf.length > 0) {
  //     addressLine = careOf + "$$$" + billingAddress;
  //   } else {
  //     addressLine = billingAddress;
  //   }
  //   let billingAddressObj = {
  //     key: "address",
  //     value: addressLine,
  //     checkoutId: paymentId,
  //   };

  //   axios
  //     .post(
  //       "/annualReportPackage/updatePaymentHeaderBillingInfo",
  //       billingAddressObj,
  //       userSessionAuthKeyReturnValue
  //     )
  //     .then((updateCompanyNameResponse) => {});
  // }

  sideBarCallback = (value) => {
    if (value) {
      this.toast.show({
        severity: "info",
        summary: "Info",
        detail: TranslationFile.CompleteCurrentPageText[userSelectedLanguage],
        life: 5000
      });
      this.setState({
        reRender: true
      });
    }
  };

  componentDidMount() {
    if (this.state.run) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    let userTourGuide = JSON.parse(localStorage.getItem("TourGuide")) || false;

    if (userTourGuide) {
      if (
        tourGuidePages != null &&
        tourGuidePages.length > 0 &&
        tourGuidePages.includes(currentPageTourGuideName)
      ) {
        setTimeout(() => {
          this.setState({ run: false });
        }, 200);
      } else {
        setTimeout(() => {
          this.setState({ run: true });
        }, 200);
      }
    }
    // this.loadNetsScript();
    //   const dibsscript = document.createElement("dibsscript");

    // dibsscript.src = "https://test.checkout.dibspayment.eu/v1/checkout.js?v=1";

    // dibsscript.async = true;

    // dibsscript.onload = () => this.scriptLoaded();

    // document.head.appendChild(dibsscript);
    // document.body.appendChild(dibsscript);
    // this.div.appendChild(dibsscript);
  }

  tourStatus = (e) => {
    this.setState({ run: e });
  };

  previewPdfLocal(gCurrentReportGUIDFromUrl) {
    this.setState({ pdfLoading: true });
    setTimeout(() => {
      let pdfReturn = previewPdf(gCurrentReportGUIDFromUrl);
      this.setState({ pdfLoading: !pdfReturn });
    }, 500);
  }

  discountBtnOnClick() {
    const { discountInput, totalPriceIncMoms, totalPriceExcMoms } = this.state;

    if (null != discountInput && discountInput) {
      let discountInputTrim = discountInput.trim();
      this.setState({
        discountInput: discountInputTrim
      });

      let removeEmptySpaces = discountInputTrim.replace(/\s+/g, "");

      let config = setUserSessionAuthKey();
      let totalPrice = totalPriceExcMoms.replace(",", ".");
      totalPrice = Number(totalPrice.replace(/\s+/g, ""));

      if (
        removeEmptySpaces.length > 0 &&
        userSessionAuthKeyReturnValue &&
        config
      ) {
        this.setState({
          discountApplyLoading: true
        });

        config.params = {
          totalAmount: totalPrice,
          couponCode: discountInputTrim
        };

        axios
          .get("/RBLOffer/ApplyOffer", config)
          .then((response) => {
            this.setState({
              discountResponse: response.data,
              discountErrorResponseStatus: false,
              discountApplyLoading: false
            });

            gDiscountErrorResponseStatus = false;

            if (response.data.discountTotalIncVat == 0) {
              this.setState({
                iframeKey: 0,
                paymentId: null,
                showPaymentIframe: false,
                showPaymentAccordion: false
              });
            }

            if (this.msgs.current) {
              this.msgs.current.clear();

              let detailsMsg = response.data.discountValue;

              if (response.data.discountType == "Fixed")
                detailsMsg = detailsMsg + " kr";

              this.msgs.current.show({
                id: "1",
                sticky: true,
                severity: this.setMessageToastSeverity(
                  response.data.responseCode
                ),
                detail:
                  detailsMsg +
                  " " +
                  TranslationFile[response.data.responseMessage][
                    userSelectedLanguage
                  ],
                closable: false
              });
              //call iFrame
              if (paymentStatus != null)
                this.createPaymentData("update", false);
            }
          })
          .catch((error) => {
            this.setState({
              discountResponse: error.response,
              discountErrorResponseStatus: true,
              discountApplyLoading: false
            });
            gDiscountErrorResponseStatus = true;
            if (this.errorMsgs.current) {
              this.errorMsgs.current.clear();
              this.errorMsgs.current.show({
                id: "1",
                sticky: true,
                severity: this.setMessageToastSeverity(
                  error.response.data.responseCode
                ),
                detail:
                  TranslationFile[error.response.data.responseMessage][
                    userSelectedLanguage
                  ],
                closable: false
              });
            }
          });
      }
    }
  }

  setMessageToastSeverity(responseCode) {
    switch (responseCode) {
      case 1:
        return "success";
      case 2:
      case 4:
      case 5:
        return "error";
      case 3:
        return "warn";
    }
  }

  removeAppliedCoupon() {
    this.setState({
      discountInput: null,
      discountResponse: null,
      discountErrorResponseStatus: null
    });
    gDiscountErrorResponseStatus = null;

    this.createPaymentData(paymentStatus, false);
  }

  // navigateToDSE() {
  //   let navigationUrl =
  //     "/annualreport/" + gCurrentReportGUIDFromUrl + "/digitalSignature";
  //   setTimeout(() => {
  //     this.props.history.push(navigationUrl);
  //   }, 2000);
  // }

  render() {
    const {
      companyName,
      organizationNumber,
      companyNameFromDB,
      postalCode,
      city,
      toggleOpen,
      activeIndex,
      sideBarStatus,
      userCompanyType,
      paymentType,
      accountingCompanyOrgName,
      accountingCompanyPostalCode,
      accountingCompanyCity,
      pricesList,
      defaultPrice,
      discountCodeRupee,
      totalReportCount,
      totalUsedReportCount,
      remainingReportCount,
      currentFinancialYear,
      activePackageAvailable,
      registrationNoFromDB,
      postalCodeFromDB,
      cityFromDB,
      totalPriceExcMoms,
      totalMoms,
      totalPriceIncMoms,
      billingAddress,
      careOf,
      name,
      lastName,
      isLoading,
      showPaymentAccordion,
      showPaymentIframe,
      billingInfoEdit,
      paymentId,
      billingType,
      contactNumber,
      countryCode,
      payBtnEnable,
      discountInput,
      discountResponse,
      discountErrorResponseStatus,
      discountApplyLoading,
      width,
      accessLevel
    } = this.state;
    const { prices, login, companyInformation } = this.props;
    this.handleCartPrice();
    this.updateGridDataNameColumn(gridData);
    this.checkUpdatedBillingInfo();
    let sideBarClassName = "";
    if (!sideBarStatus || sideBarStatus == undefined) {
      sideBarClassName = "payment-div-sidebar";
    } else {
      sideBarClassName = "payment-div";
    }

    return (
      <div className="notes-main-div" style={{ overflow: "hidden" }}>
        {accessLevel == 4 ? (
          <NoAccess />
        ) : (
          <>
            <Joyride
              continuous
              run={this.state.run}
              disableBeacon={true}
              showProgress={false}
              showSkipButton
              steps={steps}
              scrollToFirstStep
              scrollToSteps={true}
              disableScrolling={false}
              scrollOffset={100}
              locale={{
                last: "End",
                back: "Back",
                next: "Next",
                skip: "Skip"
              }}
              styles={{
                options: {
                  zIndex: 10000
                }
              }}
            />

            <Toast
              ref={(el) => {
                this.toast = el;
              }}
              style={{ marginTop: "34%" }}
            ></Toast>

            <NavBarHeader
              callBack={this.callback}
              isAppPortal={true}
              className="netsPayment-NavBarHeader"
            />

            <div className="paymentSideBar">
              <Sidebar
                sideBarStatus={this.sideBarStatus.bind(this)}
                sideBarCallback={this.sideBarCallback.bind(this)}
                tourStatus={this.tourStatus.bind(this)}
              />
            </div>

            {isLoading ? (
              <div className="ISLoading">
                <i
                  className="pi pi-spin pi-spinner"
                  style={{ fontSize: "2rem" }}
                ></i>
              </div>
            ) : (
              <div>
                {this.state.paymentEntryNo > 0 ? (
                  <div className="already-paid-div">
                    <center>
                      {
                        TranslationFile.PaymentPaidAlreadyText[
                          userSelectedLanguage
                        ]
                      }
                    </center>
                    <center style={{ marginTop: "20px" }}>
                      <Button
                        label={TranslationFile.continue[userSelectedLanguage]}
                        onClick={() => this.nextPage()}
                      />
                    </center>
                  </div>
                ) : (
                  <div className={sideBarClassName}>
                    <Row className="row-payment-div1">
                      {showPayment != undefined &&
                      !showPayment &&
                      !payFromHome ? (
                        <div className="payment-restriction">
                          <center>
                            {
                              TranslationFile.PaymentOwnerOnlyPayText[
                                userSelectedLanguage
                              ]
                            }
                          </center>
                        </div>
                      ) : (
                        <Col
                          xs={8}
                          sm={8}
                          md={8}
                          lg={8}
                          xl={8}
                          style={{
                            width: "100%",
                            marginLeft: "0px"
                          }}
                          className="Payment_Main_Div"
                        >
                          <div
                            className={
                              sideBarStatus
                                ? "netsPayment-header netsPayment-header-open"
                                : "netsPayment-header netsPayment-header-sidebar-closed"
                            }
                          >
                            <div>
                              {" "}
                              <div>
                                <div className="Page_Title_manage_div">
                                  <div className="Page_Title_T1_Management">
                                    {companyName}
                                  </div>
                                  <div className="Page_Title_management_Year">
                                    {currentFinancialYear}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="pdf-preview-div">
                              {" "}
                              <span>
                                <Button
                                  type="button"
                                  icon="pi pi-file-pdf"
                                  outlined
                                  style={{
                                    borderRadius: "70px",
                                    marginRight: "1%",
                                    display:
                                      annualReportHeaderAPIResp.reportID ==
                                        null && "none"
                                  }}
                                  tooltip={
                                    TranslationFile.pdfPreview[
                                      userSelectedLanguage
                                    ]
                                  }
                                  tooltipOptions={{ position: "bottom" }}
                                  onClick={() =>
                                    this.previewPdfLocal(
                                      gCurrentReportGUIDFromUrl
                                    )
                                  }
                                />
                              </span>
                              <span>
                                {toggleOpen == true ? (
                                  <Button
                                    value={toggleOpen}
                                    icon="pi pi-chevron-down"
                                    title="Expand"
                                    onClick={(e) =>
                                      this.handleChange(toggleOpen)
                                    }
                                    className="toggle-open"
                                  />
                                ) : (
                                  <Button
                                    value={toggleOpen}
                                    icon="pi pi-chevron-up"
                                    title="Collapse"
                                    onClick={(e) =>
                                      this.handleChange(toggleOpen)
                                    }
                                    className="toggle-open"
                                  />
                                )}
                              </span>
                            </div>
                          </div>
                          <Accordion
                            multiple
                            activeIndex={activeIndex}
                            onTabChange={(e) =>
                              this.setState({ activeIndex: e.index })
                            }
                            ref={this.myRef}
                            className={
                              sideBarStatus
                                ? "payment-accordion payment-accordion-open"
                                : "payment-accordion payment-accordion-sidebar-closed"
                            }
                          >
                            {activePackageAvailable && !payFromHome && (
                              <AccordionTab
                                header={
                                  TranslationFile.myProfilepackages[
                                    userSelectedLanguage
                                  ]
                                }
                                className="IS-Accordion-Tab"
                              >
                                <div>
                                  <center>
                                    <b>
                                      {" "}
                                      {
                                        TranslationFile
                                          .PaymentChooseEarliestPackText[
                                          userSelectedLanguage
                                        ]
                                      }
                                    </b>
                                  </center>
                                  <br></br>

                                  {previouslyBoughtPackages && (
                                    <center>
                                      <DataTable
                                        value={previouslyBoughtPackages}
                                        tableStyle={{ width: "60rem" }}
                                        paginator
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                        rowsPerPageOptions={[5, 10, 15]}
                                        className="previouslyBoughtPackagesTable"
                                        rows={5}
                                      >
                                        <Column
                                          className="payment-packageName"
                                          header={
                                            TranslationFile.QuantityText[
                                              userSelectedLanguage
                                            ]
                                          }
                                          field="packageName"
                                          body={this.packageNameBodyTemplate}
                                        ></Column>
                                        <Column
                                          className="payment-quantity"
                                          header={
                                            TranslationFile.PackageNameText[
                                              userSelectedLanguage
                                            ]
                                          }
                                          field="quantity"
                                          body={this.quantityLevelBodyTemplate}
                                        ></Column>
                                        <Column
                                          className="payment-startingDate"
                                          header={
                                            TranslationFile
                                              .IncomestateYearStartdate[
                                              userSelectedLanguage
                                            ]
                                          }
                                          field="startingDate"
                                          body={this.startingDateBodyTemplate}
                                        ></Column>
                                        <Column
                                          className="payment-validUntil"
                                          header={
                                            TranslationFile
                                              .IncomestateYearEnddate[
                                              userSelectedLanguage
                                            ]
                                          }
                                          field="validUntil"
                                          body={this.validUntilBodyTemplate}
                                        ></Column>
                                        <Column
                                          className="payment-maxUsage"
                                          field="maxUsage"
                                          header={
                                            TranslationFile.TotalPackagesText[
                                              userSelectedLanguage
                                            ]
                                          }
                                          body={this.maxUsageBodyTemplate}
                                        ></Column>

                                        <Column
                                          className="payment-actualUsage"
                                          field="actualUsage"
                                          header={
                                            TranslationFile.UsedPackagesText[
                                              userSelectedLanguage
                                            ]
                                          }
                                          body={this.actualUsageBodyTemplate}
                                        ></Column>
                                        <Column
                                          className="payment-remaining"
                                          header={
                                            TranslationFile
                                              .remainingPackagesText[
                                              userSelectedLanguage
                                            ]
                                          }
                                          body={
                                            this.remainingReportsBodyTemplate
                                          }
                                        ></Column>
                                      </DataTable>
                                      {/* <br></br>
                                  <div className="year-limit-info">
                                    <center>
                                      <i
                                        className="pi pi-info-circle"
                                        style={{ marginRight: "5px" }}
                                      ></i>
                                      <span style={{ marginRight: "2px" }}>
                                        {
                                          TranslationFile.PaymentReportText1[
                                            userSelectedLanguage
                                          ]
                                        }
                                      </span>
                                    </center>
                                  </div> */}
                                      <Button
                                        onClick={() =>
                                          this.finalPayForCurrentReport()
                                        }
                                        disabled={payBtnEnable}
                                        className="usePackageBtn"
                                      >
                                        {
                                          TranslationFile.UsePackagesText[
                                            userSelectedLanguage
                                          ]
                                        }
                                      </Button>
                                    </center>
                                  )}
                                  <br />
                                </div>
                              </AccordionTab>
                            )}

                            {(!activePackageAvailable || payFromHome) && (
                              <AccordionTab
                                header={
                                  TranslationFile.CartText[userSelectedLanguage]
                                }
                                className="IS-Accordion-Tab"
                              >
                                <div>
                                  <DataTable
                                    value={gridData}
                                    tableStyle={{ minWidth: "50rem" }}
                                  >
                                    <Column
                                      header={
                                        TranslationFile.PackageNameText[
                                          userSelectedLanguage
                                        ]
                                      }
                                      field="title"
                                    ></Column>
                                    <Column
                                      header={
                                        TranslationFile.UnitPriceText[
                                          userSelectedLanguage
                                        ]
                                      }
                                      field="price"
                                      body={this.unitPriceBodyTemplate}
                                    ></Column>

                                    <Column
                                      header={
                                        TranslationFile.QuantityText[
                                          userSelectedLanguage
                                        ]
                                      }
                                      className="payment-quantity"
                                      field="quantity"
                                      body={this.quantityBodyTemplate}
                                    ></Column>

                                    <Column
                                      header={
                                        TranslationFile.PriceText[
                                          userSelectedLanguage
                                        ]
                                      }
                                      body={this.priceBodyTemplate}
                                    ></Column>

                                    <Column
                                      body={this.removeBodyTemplate}
                                    ></Column>
                                  </DataTable>
                                </div>
                                <br></br>

                                <div className="payment_totalCalc_Div">
                                  <div class="summary-container">
                                    <div class="discount-row">
                                      <label class="discountLbl">
                                        {" "}
                                        {
                                          TranslationFile.discountCode[
                                            userSelectedLanguage
                                          ]
                                        }
                                      </label>
                                      <div class="discount-input-group">
                                        <InputText
                                          class="discount-input"
                                          placeholder={
                                            TranslationFile.enterCode[
                                              userSelectedLanguage
                                            ]
                                          }
                                          value={
                                            discountInput == null
                                              ? ""
                                              : discountInput
                                          }
                                          onChange={(e) =>
                                            this.setState({
                                              discountInput: e.target.value
                                            })
                                          }
                                        />

                                        <button
                                          class="apply-btn"
                                          onClick={() =>
                                            this.discountBtnOnClick()
                                          }
                                        >
                                          {
                                            TranslationFile.apply[
                                              userSelectedLanguage
                                            ]
                                          }
                                        </button>
                                      </div>
                                    </div>

                                    {discountApplyLoading == true ? (
                                      <center>
                                        <ProgressSpinner
                                          style={{
                                            width: "50px"
                                          }}
                                        />
                                      </center>
                                    ) : (
                                      <>
                                        {!discountErrorResponseStatus &&
                                        null != discountErrorResponseStatus ? (
                                          <>
                                            <div
                                              className="card flex justify-content-center"
                                              style={{
                                                border: "none",
                                                height: "4em"
                                              }}
                                            >
                                              <Messages ref={this.msgs} />
                                            </div>

                                            <div className="removeAppliedCouponDiv">
                                              <i
                                                onClick={() =>
                                                  this.removeAppliedCoupon()
                                                }
                                              >
                                                {
                                                  TranslationFile
                                                    .removeAppliedCoupon[
                                                    userSelectedLanguage
                                                  ]
                                                }
                                              </i>
                                            </div>

                                            <div class="price-row">
                                              <span>
                                                {
                                                  TranslationFile.TotalExMoms[
                                                    userSelectedLanguage
                                                  ]
                                                }
                                              </span>
                                              <span>
                                                {
                                                  discountResponse.discountTotalExVat
                                                }{" "}
                                                kr
                                              </span>
                                            </div>
                                            <div class="price-row">
                                              <span>
                                                {" "}
                                                <b>
                                                  {
                                                    TranslationFile.discount[
                                                      userSelectedLanguage
                                                    ]
                                                  }
                                                </b>
                                              </span>
                                            </div>
                                            <div class="price-row">
                                              <span>{discountInput}</span>

                                              <div class="price-right">
                                                <span class="new-price">
                                                  {discountResponse.discountValue
                                                    .toString()
                                                    .replace(".", ",")}
                                                </span>
                                              </div>
                                            </div>
                                            <div class="price-row">
                                              <span>
                                                {" "}
                                                {
                                                  TranslationFile.discountAmt[
                                                    userSelectedLanguage
                                                  ]
                                                }
                                              </span>

                                              <div class="price-right">
                                                <span class="new-price">
                                                  -{" "}
                                                  {discountResponse.amountDifference
                                                    .toString()
                                                    .split(".").length >= 2
                                                    ? discountResponse.amountDifference
                                                        .toString()
                                                        .split(".")[1].length ==
                                                      1
                                                      ? discountResponse.amountDifference
                                                          .toString()
                                                          .replace(".", ",") +
                                                        "0"
                                                      : discountResponse.amountDifference
                                                          .toString()
                                                          .replace(".", ",")
                                                    : discountResponse.amountDifference +
                                                      ",00"}{" "}
                                                  kr
                                                </span>
                                              </div>
                                            </div>
                                            <div class="price-row">
                                              <span>
                                                {" "}
                                                {
                                                  TranslationFile.MomsText[
                                                    userSelectedLanguage
                                                  ]
                                                }
                                              </span>

                                              <div class="price-right">
                                                <span class="new-price">
                                                  {discountResponse.discountVat
                                                    .toString()
                                                    .split(".").length >= 2
                                                    ? discountResponse.discountVat
                                                        .toString()
                                                        .split(".")[1].length ==
                                                      1
                                                      ? discountResponse.discountVat
                                                          .toString()
                                                          .replace(".", ",") +
                                                        "0"
                                                      : discountResponse.discountVat
                                                          .toString()
                                                          .replace(".", ",")
                                                    : discountResponse.discountVat +
                                                      ",00"}{" "}
                                                  kr
                                                </span>
                                              </div>
                                            </div>
                                            <div class="price-row total">
                                              <span>
                                                {
                                                  TranslationFile
                                                    .TotalIncMomsText[
                                                    userSelectedLanguage
                                                  ]
                                                }
                                              </span>

                                              <div class="price-right">
                                                <span class="new-price">
                                                  {discountResponse.discountTotalIncVat
                                                    .toString()
                                                    .replace(".", ",")}{" "}
                                                  kr
                                                </span>
                                              </div>
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            {discountErrorResponseStatus &&
                                              null !=
                                                discountErrorResponseStatus &&
                                              discountResponse != "" && (
                                                <>
                                                  <div
                                                    className="card flex justify-content-center"
                                                    style={{
                                                      border: "none",
                                                      height: "4em"
                                                    }}
                                                  >
                                                    <Messages
                                                      ref={this.errorMsgs}
                                                    />
                                                  </div>
                                                </>
                                              )}

                                            <div class="price-row">
                                              <span>
                                                {
                                                  TranslationFile.TotalExMoms[
                                                    userSelectedLanguage
                                                  ]
                                                }
                                              </span>
                                              <span>
                                                {totalPriceExcMoms} kr
                                              </span>
                                            </div>

                                            <div class="price-row">
                                              <span>
                                                {" "}
                                                {
                                                  TranslationFile.MomsText[
                                                    userSelectedLanguage
                                                  ]
                                                }
                                              </span>
                                              <span>{totalMoms} kr</span>
                                            </div>

                                            <div class="price-row total">
                                              <span>
                                                {" "}
                                                {
                                                  TranslationFile
                                                    .TotalIncMomsText[
                                                    userSelectedLanguage
                                                  ]
                                                }
                                              </span>
                                              <span>
                                                {" "}
                                                {totalPriceIncMoms} kr
                                              </span>
                                            </div>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                                <div className="payment-extra-text">
                                  {
                                    TranslationFile.PaymentExtraText[
                                      userSelectedLanguage
                                    ]
                                  }
                                </div>

                                <div className="paymentPackageCarouselCard">
                                  <Carousel
                                    value={carouselData}
                                    numVisible={3}
                                    numScroll={1}
                                    circular
                                    autoplayInterval={20000000}
                                    responsiveOptions={responsiveOptions}
                                    itemTemplate={(e) =>
                                      this.packageCarouselRender(e)
                                    }
                                    className="main-carousel-card"
                                    // orientation={
                                    //   width <= 600 ? "vertical" : "horizontal"
                                    // }
                                  />
                                </div>
                              </AccordionTab>
                            )}
                            {(!activePackageAvailable || payFromHome) && (
                              <AccordionTab
                                header={
                                  TranslationFile.BillingInfoText[
                                    userSelectedLanguage
                                  ]
                                }
                                className="IS-Accordion-Tab"
                              >
                                <div className="payment-billing-type">
                                  <div className="billing-content">
                                    <SelectButton
                                      value={this.state.billingType}
                                      onChange={(e) =>
                                        this.billingTypeTabOnChange(e.value)
                                      }
                                      options={this.billingTypeOptions}
                                      disabled={showPaymentIframe && true}
                                    />
                                  </div>
                                  <div className="edit-billing-content">
                                    {showPaymentAccordion && (
                                      <Button
                                        label={
                                          TranslationFile
                                            .netsPaymentEditBillingInfo[
                                            userSelectedLanguage
                                          ]
                                        }
                                        icon="pi pi-pencil"
                                        onClick={() => this.editBillingInfo()}
                                      />
                                    )}
                                  </div>
                                </div>

                                <div
                                  className="payment_information_fill-div"
                                  style={{ padding: "1% 10%" }}
                                >
                                  <div className="mand-bill-info">
                                    <center>
                                      <i
                                        className="pi pi-info-circle"
                                        style={{ marginRight: "5px" }}
                                      ></i>
                                      <span style={{ marginRight: "2px" }}>
                                        {
                                          TranslationFile.FillBilingInfoText[
                                            userSelectedLanguage
                                          ]
                                        }
                                      </span>
                                    </center>
                                  </div>
                                  <br></br>
                                  {billingType == "Private" ||
                                  billingType ===
                                    TranslationFile.loginPrivateText[
                                      userSelectedLanguage
                                    ] ? (
                                    <div>
                                      <Row>
                                        <Col>
                                          <Row>
                                            <Col>
                                              <label
                                                htmlFor="Name"
                                                className="companyInformationTextBoxTitle"
                                              >
                                                {
                                                  TranslationFile.FirstNameText[
                                                    userSelectedLanguage
                                                  ]
                                                }
                                                <p className="companyInformationMandatoryStart">
                                                  *
                                                </p>
                                              </label>
                                              {/* <InputText
                                                value={name}
                                                onChange={(e) =>
                                                  this.paymentNameOnChange(
                                                    e,
                                                    "name"
                                                  )
                                                }
                                                disabled={
                                                  billingInfoEdit && true
                                                }
                                                className={
                                                  " paymentOrgFName" +
                                                  (this.state.invalidFields &&
                                                  this.state.invalidFields.name
                                                    ? "invalid-field"
                                                    : "")
                                                }
                                                autocomplete="new-password"
                                              /> */}
                                              <InputText
                                                value={name}
                                                onChange={(e) =>
                                                  this.paymentNameOnChange(
                                                    e,
                                                    "name"
                                                  )
                                                }
                                                disabled={
                                                  billingInfoEdit && true
                                                }
                                                className={
                                                  "paymentOrgFName " +
                                                  (this.state.invalidFields &&
                                                  this.state.invalidFields.name
                                                    ? "invalid-field"
                                                    : "")
                                                }
                                                autocomplete="new-password"
                                              />
                                            </Col>
                                            <Col>
                                              <label
                                                htmlFor="Name"
                                                className="companyInformationTextBoxTitle"
                                              >
                                                {
                                                  TranslationFile.LastName[
                                                    userSelectedLanguage
                                                  ]
                                                }
                                                <p className="companyInformationMandatoryStart">
                                                  *
                                                </p>
                                              </label>
                                              <InputText
                                                value={lastName}
                                                onChange={(e) =>
                                                  this.paymentNameOnChange(
                                                    e,
                                                    "lastName"
                                                  )
                                                }
                                                disabled={
                                                  billingInfoEdit && true
                                                }
                                                className={
                                                  "paymentOrgLName " +
                                                  (this.state.invalidFields &&
                                                  this.state.invalidFields
                                                    .lastName
                                                    ? "invalid-field"
                                                    : "")
                                                }
                                                autocomplete="new-password"
                                              />
                                            </Col>
                                          </Row>
                                        </Col>

                                        <Col className="privateEmailIdCol">
                                          <label
                                            htmlFor="Email"
                                            className="companyInformationTextBoxTitle"
                                            style={{ alignItems: "center" }}
                                          >
                                            {
                                              TranslationFile.FooterEmailLabel[
                                                userSelectedLanguage
                                              ]
                                            }
                                            <p className="companyInformationMandatoryStart">
                                              *
                                            </p>
                                            (
                                            <i
                                              className="pi pi-info-circle"
                                              style={{
                                                margin: "0px 2px",
                                                color: "#0077B6"
                                              }}
                                            ></i>
                                            {
                                              TranslationFile
                                                .InvoiceSenttoMailText[
                                                userSelectedLanguage
                                              ]
                                            }
                                            )
                                          </label>
                                          <InputText
                                            value={this.state.emailId}
                                            onChange={(e) =>
                                              this.paymentEmailOnChange(e)
                                            }
                                            disabled={billingInfoEdit && true}
                                            className={
                                              "paymentEmailId " +
                                              (this.state.invalidFields &&
                                              this.state.invalidFields.emailId
                                                ? "invalid-field"
                                                : "")
                                            }
                                            autocomplete="new-password"
                                          />
                                        </Col>
                                      </Row>
                                      <br></br>

                                      <Row>
                                        <Col>
                                          <span>
                                            <label
                                              htmlFor="OrganizationNumber"
                                              className="companyInformationTextBoxTitle"
                                            >
                                              {
                                                TranslationFile
                                                  .dashboardOrgNumber[
                                                  userSelectedLanguage
                                                ]
                                              }
                                            </label>
                                            <div>
                                              <InputMask
                                                mask="999999-9999"
                                                value={organizationNumber}
                                                onComplete={(e) =>
                                                  this.organizationNoOnComplete(
                                                    e
                                                  )
                                                }
                                                onChange={(e) =>
                                                  this.organizationNoOnChange(e)
                                                }
                                                useGrouping={false}
                                                disabled={
                                                  billingInfoEdit && true
                                                }
                                                className="paymentOrgNo "
                                                autocomplete="new-password"
                                              />
                                            </div>
                                          </span>
                                        </Col>
                                        <Col>
                                          <span>
                                            <label
                                              htmlFor="CompanyName"
                                              className="companyInformationTextBoxTitle"
                                            >
                                              {
                                                TranslationFile
                                                  .IncomestateCompanyOrgName[
                                                  userSelectedLanguage
                                                ]
                                              }
                                            </label>

                                            <div>
                                              <InputText
                                                onChange={(e) => {
                                                  this.companyNameOnChange(e);
                                                  this.setState({
                                                    companyName: e.target.value
                                                  });
                                                }}
                                                value={companyName}
                                                disabled={
                                                  billingInfoEdit && true
                                                }
                                                className="paymentOrgName "
                                                autocomplete="new-password"
                                              />
                                            </div>
                                          </span>
                                        </Col>
                                      </Row>
                                    </div>
                                  ) : (
                                    <div>
                                      <Row>
                                        <Col>
                                          <span>
                                            <label
                                              htmlFor="OrganizationNumber"
                                              className="companyInformationTextBoxTitle"
                                            >
                                              {
                                                TranslationFile
                                                  .dashboardOrgNumber[
                                                  userSelectedLanguage
                                                ]
                                              }
                                              <p className="companyInformationMandatoryStart">
                                                *
                                              </p>
                                            </label>
                                            <div>
                                              <InputMask
                                                mask="999999-9999"
                                                value={organizationNumber}
                                                onComplete={(e) =>
                                                  this.organizationNoOnComplete(
                                                    e
                                                  )
                                                }
                                                onChange={(e) =>
                                                  this.organizationNoOnChange(e)
                                                }
                                                useGrouping={false}
                                                disabled={
                                                  billingInfoEdit && true
                                                }
                                                className={
                                                  "paymentOrgNo " +
                                                  (this.state.invalidFields &&
                                                  this.state.invalidFields
                                                    .organizationNumber
                                                    ? "invalid-field"
                                                    : "")
                                                }
                                                autocomplete="new-password"
                                              />
                                            </div>
                                          </span>
                                        </Col>
                                        <Col>
                                          <span>
                                            <label
                                              htmlFor="CompanyName"
                                              className="companyInformationTextBoxTitle"
                                            >
                                              {
                                                TranslationFile
                                                  .IncomestateCompanyOrgName[
                                                  userSelectedLanguage
                                                ]
                                              }
                                              <p className="companyInformationMandatoryStart">
                                                *
                                              </p>
                                            </label>

                                            <div>
                                              <InputText
                                                onChange={(e) =>
                                                  this.companyNameOnChange(e)
                                                }
                                                value={companyName}
                                                disabled={
                                                  billingInfoEdit && true
                                                }
                                                className={
                                                  "paymentOrgName " +
                                                  (this.state.invalidFields &&
                                                  this.state.invalidFields
                                                    .companyName
                                                    ? "invalid-field"
                                                    : "")
                                                }
                                                autocomplete="new-password"
                                              />
                                            </div>
                                          </span>
                                        </Col>
                                      </Row>
                                      <br></br>
                                      <Row>
                                        <Col>
                                          <Row>
                                            <Col>
                                              <label
                                                htmlFor="Name"
                                                className="companyInformationTextBoxTitle"
                                              >
                                                {
                                                  TranslationFile.FirstNameText[
                                                    userSelectedLanguage
                                                  ]
                                                }
                                                <p className="companyInformationMandatoryStart">
                                                  *
                                                </p>
                                              </label>
                                              <InputText
                                                value={name}
                                                onChange={(e) =>
                                                  this.paymentNameOnChange(
                                                    e,
                                                    "name"
                                                  )
                                                }
                                                disabled={
                                                  billingInfoEdit && true
                                                }
                                                className={
                                                  "paymentOrgFName " +
                                                  (this.state.invalidFields &&
                                                  this.state.invalidFields.name
                                                    ? "invalid-field"
                                                    : "")
                                                }
                                                autocomplete="new-password"
                                              />
                                            </Col>
                                            <Col>
                                              <label
                                                htmlFor="Name"
                                                className="companyInformationTextBoxTitle"
                                              >
                                                {
                                                  TranslationFile.LastName[
                                                    userSelectedLanguage
                                                  ]
                                                }
                                                <p className="companyInformationMandatoryStart">
                                                  *
                                                </p>
                                              </label>
                                              <InputText
                                                value={lastName}
                                                onChange={(e) =>
                                                  this.paymentNameOnChange(
                                                    e,
                                                    "lastName"
                                                  )
                                                }
                                                disabled={
                                                  billingInfoEdit && true
                                                }
                                                className={
                                                  " paymentOrgLName " +
                                                  (this.state.invalidFields &&
                                                  this.state.invalidFields
                                                    .lastName
                                                    ? "invalid-field"
                                                    : "")
                                                }
                                                autocomplete="new-password"
                                              />
                                            </Col>
                                          </Row>
                                        </Col>

                                        <Col className="companyEmailIdCol">
                                          <label
                                            htmlFor="Email"
                                            className="companyInformationTextBoxTitle"
                                          >
                                            {
                                              TranslationFile.FooterEmailLabel[
                                                userSelectedLanguage
                                              ]
                                            }
                                            <p
                                              className="companyInformationMandatoryStart"
                                              style={{ marginRight: "5px" }}
                                            >
                                              *
                                            </p>
                                            (
                                            {
                                              TranslationFile
                                                .InvoiceSenttoMailText[
                                                userSelectedLanguage
                                              ]
                                            }
                                            )
                                          </label>
                                          <InputText
                                            value={this.state.emailId}
                                            onChange={(e) =>
                                              this.paymentEmailOnChange(e)
                                            }
                                            disabled={billingInfoEdit && true}
                                            className={
                                              "paymentEmailId " +
                                              (this.state.invalidFields &&
                                              this.state.invalidFields.emailId
                                                ? "invalid-field"
                                                : "")
                                            }
                                            autocomplete="new-password"
                                          />
                                        </Col>
                                      </Row>
                                    </div>
                                  )}

                                  <br></br>
                                  <Row>
                                    <Col>
                                      <label
                                        htmlFor="Address"
                                        className="companyInformationTextBoxTitle"
                                      >
                                        C/o
                                      </label>

                                      <InputText
                                        value={careOf}
                                        onChange={(e) =>
                                          this.billingAddressOnChange(e, "CO")
                                        }
                                        disabled={billingInfoEdit && true}
                                        className="paymentCareOf"
                                        autocomplete="new-password"
                                      />
                                    </Col>
                                    <Col>
                                      <label
                                        htmlFor="Address"
                                        className="companyInformationTextBoxTitle"
                                      >
                                        {
                                          TranslationFile.AddressLine1[
                                            userSelectedLanguage
                                          ]
                                        }
                                        <p className="companyInformationMandatoryStart">
                                          *
                                        </p>
                                      </label>

                                      <InputText
                                        value={billingAddress}
                                        onChange={(e) =>
                                          this.billingAddressOnChange(
                                            e,
                                            "Address"
                                          )
                                        }
                                        disabled={billingInfoEdit && true}
                                        className={
                                          "paymentOrgAddress " +
                                          (this.state.invalidFields &&
                                          this.state.invalidFields
                                            .billingAddress
                                            ? "invalid-field"
                                            : "")
                                        }
                                        autocomplete="new-password"
                                      />
                                    </Col>
                                  </Row>
                                  <br></br>
                                  <Row>
                                    <Col>
                                      <Row>
                                        <Col>
                                          <span>
                                            <label
                                              htmlFor="PostalCode"
                                              className="companyInformationTextBoxTitle"
                                            >
                                              {
                                                TranslationFile
                                                  .IncomestateCompanyPostalcode[
                                                  userSelectedLanguage
                                                ]
                                              }
                                              <p className="companyInformationMandatoryStart">
                                                *
                                              </p>
                                            </label>
                                            <div>
                                              <InputText
                                                onChange={(e) =>
                                                  this.PostalcodeOnChange(e)
                                                }
                                                value={this.state.postalCode}
                                                disabled={
                                                  billingInfoEdit && true
                                                }
                                                className={
                                                  "paymentPostalCode " +
                                                  (this.state.invalidFields &&
                                                  this.state.invalidFields
                                                    .postalCode
                                                    ? "invalid-field"
                                                    : "")
                                                }
                                                //  maxLength={5}
                                                autocomplete="new-password"
                                              />
                                            </div>
                                          </span>
                                        </Col>
                                        <Col>
                                          <span>
                                            <label
                                              htmlFor="City"
                                              className="companyInformationTextBoxTitle"
                                            >
                                              {
                                                TranslationFile
                                                  .IncomestateCompanyCity[
                                                  userSelectedLanguage
                                                ]
                                              }
                                              <p className="companyInformationMandatoryStart">
                                                *
                                              </p>
                                            </label>

                                            <div>
                                              <InputText
                                                onChange={(e) =>
                                                  this.cityOnChange(e)
                                                }
                                                value={this.state.city}
                                                disabled={
                                                  billingInfoEdit && true
                                                }
                                                className={
                                                  " paymentCity " +
                                                  (this.state.invalidFields
                                                    ?.city
                                                    ? "invalid-field"
                                                    : "")
                                                }
                                                autocomplete="new-password"
                                              />
                                            </div>
                                          </span>
                                        </Col>
                                      </Row>
                                    </Col>

                                    <Col>
                                      <Row>
                                        <Col>
                                          <span>
                                            <label
                                              htmlFor="City"
                                              className="companyInformationTextBoxTitle"
                                            >
                                              {
                                                TranslationFile
                                                  .ContactNumberText[
                                                  userSelectedLanguage
                                                ]
                                              }
                                            </label>

                                            <div>
                                              <InputText
                                                onChange={(e) =>
                                                  this.contactNumberOnChange(e)
                                                }
                                                value={contactNumber}
                                                disabled={
                                                  billingInfoEdit && true
                                                }
                                                className="paymentContactNo"
                                                autocomplete="new-password"
                                              />
                                            </div>
                                          </span>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                  <br></br>
                                  <center>
                                    <span style={{ marginRight: "1%" }}></span>
                                    <span>
                                      {discountResponse != null &&
                                      discountResponse.discountTotalIncVat ==
                                        0 ? (
                                        <>
                                          {annualReportHeaderAPIResp != null &&
                                          annualReportHeaderAPIResp.reportID ==
                                            null ? (
                                            <>
                                              <Button
                                                label={
                                                  TranslationFile.nextBtn[
                                                    userSelectedLanguage
                                                  ]
                                                }
                                                icon="pi pi-arrow-right"
                                                onClick={() =>
                                                  this.checkInputFields(
                                                    true,
                                                    false
                                                  )
                                                }
                                              />
                                            </>
                                          ) : (
                                            <>
                                              <Button
                                                label="Go To Review"
                                                icon="pi pi-arrow-down"
                                                onClick={() =>
                                                  // this.navigateToReviewPage(
                                                  //   discountResponse
                                                  // )

                                                  this.checkInputFields(
                                                    true,
                                                    true
                                                  )
                                                }
                                              />
                                            </>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          <Button
                                            label={
                                              TranslationFile
                                                .paymentProceedToPay[
                                                userSelectedLanguage
                                              ]
                                            }
                                            icon="pi pi-arrow-down"
                                            onClick={() => this.allowPayment()}
                                            disabled={showPaymentIframe && true}
                                          />
                                        </>
                                      )}
                                    </span>
                                  </center>
                                </div>
                              </AccordionTab>
                            )}
                            {(!activePackageAvailable || payFromHome) &&
                              showPaymentAccordion && (
                                <AccordionTab
                                  header={
                                    TranslationFile.PaymentText[
                                      userSelectedLanguage
                                    ]
                                  }
                                >
                                  <div>
                                    <center className="incomeStatementSaveBtnCenter">
                                      {/* {this.state.reportPaymentCheckout && (
                                    <div className="mand-bill-info">
                                      <center>
                                        <i
                                          className="pi pi-info-circle"
                                          style={{ marginRight: "5px" }}
                                        ></i>
                                        <span style={{ marginRight: "2px" }}>
                                          {
                                            TranslationFile.PaymentReportText1[
                                              userSelectedLanguage
                                            ]
                                          }
                                        </span>
                                      </center>
                                    </div>
                                  )} */}
                                      <br></br>

                                      {paymentId && showPaymentIframe ? (
                                        <div id="RBL-Payment-div">
                                          <iframe
                                            id="nets-checkout-iframe"
                                            key={this.state.iframeKey}
                                            src={`/dibs-checkout.html?paymentId=${paymentId}&currentReportGUIDFromUrl=${gCurrentReportGUIDFromUrl}`}
                                            referrerPolicy="strict-origin-when-cross-origin"
                                            allow="payment *"
                                            frameBorder="0"
                                            scrolling="no"
                                            height="1000"
                                            // width="1200"
                                          ></iframe>
                                          <br />
                                        </div>
                                      ) : (
                                        <div className="ISLoading">
                                          <i
                                            className="pi pi-spin pi-spinner"
                                            style={{ fontSize: "2rem" }}
                                          ></i>
                                        </div>
                                      )}
                                    </center>
                                  </div>
                                </AccordionTab>
                              )}
                          </Accordion>
                        </Col>
                      )}
                    </Row>
                  </div>
                )}
              </div>
            )}

            <ScrolltoTop />
            <Footer_contact_tab
              sideBar={this.state.sideBarStatus}
              isCorpPortal={false}
              isHomePage={false}
            />
          </>
        )}
      </div>
    );
  }
}
export default connect(mapStateToProps, null)(NetsPayment);
